<template lang="pug">


button.bq-btn(
    @click="chatReady && uploadFileInp.click()",
    :class="{ disabled: getFileListFetching || !chatReady }",
    data-track="dbfile_files_icon"
) + Upload File
//- button.bq-btn.bq-btn--secondary(@click="openInviteUser = true" :disabled="creatingDisabled" data-track="users_invite_icon")
//-     span.material-symbols-outlined(style="font-size:1.1rem; vertical-align:middle; margin-right:.4rem;") mail
//-     | Invite

//section.bq-info-section(:class="{ disabled: service_should_be_disabled }")
    .bq-info-row
        .bq-info-label Usage
        .bq-info-value {{ currentService.formattedSpecs.serviceStatus.storage.file }} / {{ currentService.formattedSpecs.currentPlan.storage.file }}
    //- .bq-info-row
    //-     .bq-info-label Storage
    //-     .bq-info-value {{ convertBytesToReadableStorage(currentService.dbDirInfo?.size || 0) }}
//- toolbar
.bq-toolbar(:class="{ disabled: service_should_be_disabled }")
    span.material-symbols-outlined.bq-icon(
        translate="no"
        @click="refreshFileList"
        :class="{ disabled: getFileListFetching || !chatReady, 'bq-spin': getFileListFetching }"
        data-track="dbfile_refresh"
        title="Refresh file list"
    ) refresh
    span.bq-record-count(title="Usage") {{ currentService.formattedSpecs.serviceStatus.storage.file }} / {{ currentService.formattedSpecs.currentPlan.storage.file }}
    .bq-toolbar-right
        span.bq-record-count.bq-desktop-only {{ Object.keys(checked).length }} selected
        template(v-if="chatReady")
            .bq-reindex-wrap(v-if="reindexing" title="Reindexing files for AI...")
                span.material-symbols-outlined.bq-icon.bq-spin(translate="no" style="cursor:default;") sync
                span.bq-reindex-count {{ reindexDone }}/{{ reindexTotal }}
            span.material-symbols-outlined.bq-icon(
                translate="no"
                v-else
                @click="reindexConfirm = true"
                :class="{ disabled: getFileListFetching || !checkedItemCount }"
                title="Reindex selected files for AI"
                data-track="dbfile_reindex_selected"
            ) manage_search
        //- span.material-symbols-outlined.bq-icon(
        //-     translate="no"
        //-     @click="chatReady && uploadFileInp.click()",
        //-     :class="{ disabled: getFileListFetching || !chatReady }",
        //-     data-track="dbfile_files_icon",
        //-     title="Upload Files"
        //- ) note_add
        //- The input's value is CLEARED after handing the files over, or picking the
        //- same file twice in a row does nothing at all: a file input fires `change`
        //- only when its value differs, so after cancelling the access question (which
        //- now aborts the whole batch) re-picking that same file is silently inert,
        //- with no modal, no upload, and nothing on screen to explain it. Safe to clear
        //- immediately because dbUploadFiles copies the FileList synchronously.
        input(
            type="file",
            hidden,
            multiple,
            @change="(e) => { dbUploadFiles(e.target.files, onDbUploadDone); e.target.value = ''; }",
            ref="uploadFileInp"
        )
        //- span.material-symbols-outlined.bq-icon(
        //-     translate="no"
        //-     @click="chatReady && uploadFolderInp.click()",
        //-     :class="{ disabled: getFileListFetching || !chatReady }",
        //-     data-track="dbfile_folder_icon",
        //-     title="Upload Folder"
        //- ) create_new_folder
        //- input(
        //-     type="file",
        //-     hidden,
        //-     multiple,
        //-     directory,
        //-     webkitdirectory,
        //-     @change="(e) => dbUploadFiles(e.target.files, onDbUploadDone)",
        //-     ref="uploadFolderInp"
        //- )
        span.material-symbols-outlined.bq-icon.bq-desktop-only(
            translate="no"
            @click="downloadChecked",
            :class="{ disabled: getFileListFetching || !Object.keys(checked).length || downloading }",
            data-track="dbfile_download_icon",
            title="Download Selected"
        ) download
        span.material-symbols-outlined.bq-icon.bq-icon--danger(
            translate="no"
            @click="deleteSelected = true",
            :class="{ disabled: getFileListFetching || !Object.keys(checked).length }",
            data-track="dbfile_delete_selected_icon",
            title="Delete Selected"
        ) delete


//- file table
.bq-table-wrap.bq-desktop-only(
    ref="tableRef",
    :class="{ 'bq-table-disabled': getFileListFetching, 'bq-uploading': isMyUpload, 'bq-uploading--indeterminate': isMyUpload && !uploadBytesMoving }",
    :style="isMyUpload && uploadBytesMoving ? { '--upload-progress': overallUploadProgress + '%' } : {}"
)
    //- Upload-status overlay: shown while the file list is (re)loading so the
    //- BunnyLoader (position:absolute z-index:4) doesn't bury the upload row.
    //- Rendered with z-index:5 so it sits above the overlay.
    .bq-upload-loading-status(v-if="isMyUpload && (getFileListFetching || gateLoading)")
        template(v-for="slot in activeUploadSlots" :key="slot.name")
            span.material-symbols-outlined.bq-upload-icon(translate="no") cloud_upload
            span Uploading: /#[span(translate="no") {{ slot.name }}]&nbsp;
                | {{ uploadSlotLabel(slot) }}&nbsp;
            b ({{ slot.position }}/{{ uploadCount[1] }})
    .bq-empty-drop(
        v-if="chatReady && !isMyUpload && !getFileListFetching && (!listDisplay || listDisplay?.length === 0)"
    )
        span.material-symbols-outlined(translate="no" style="font-size: 3rem") cloud_upload
        p Drop files or folders to index
    BunnyLoader(v-if="getFileListFetching || gateLoading" label="Loading...")
    //- From the drop until the upload queue has the files. A dropped folder is a
    //- directory walk before it is a file list, and the table showed nothing at
    //- all during it. Covers the table so the listing cannot be clicked while
    //- its own contents are about to change.
    .bq-drop-preparing(v-if="preparingDrop" role="status" aria-live="polite")
        BunnyLoader(:overlay="false" label="Preparing files...")
    Table(
        :key="tableKey",
        @dragover.stop.prevent="(e) => { if (!chatReady) return; e.dataTransfer.dropEffect = 'copy'; dragHere = true; }",
        @dragleave.stop.prevent="dragHere = false",
        @drop.stop.prevent="onTableDrop",
        :class="{ disabled: service_should_be_disabled, dragHere: dragHere }",
        resizable
    )
        template(v-slot:head)
            tr
                th.fixed.bq-sticky-check(style="width: 50px")
                    Checkbox(
                        @click.stop,
                        :modelValue="headerCheckState",
                        @update:modelValue="toggleHeaderCheck",
                        style="display: inline-block",
                        :disabled="!listDisplay || listDisplay.length === 0 || inMediaDir"
                    )
                    .resizer.fixed
                template(v-for="c in columnList")
                    th.overflow.bq-th-col(
                        v-if="c.value",
                        :class="{ left: c.key === 'name', 'bq-th-sorted': sortBy === c.key }",
                        :aria-sort="sortBy === c.key ? (ascending ? 'ascending' : 'descending') : 'none'",
                        :style="c.key === 'name' ? 'width:380px' : 'width:160px'"
                    )
                        //- Every column sorts, not just Filename. The arrow slot is
                        //- always rendered so the columns cannot shift width when the
                        //- sort moves; it is invisible until hover on the columns that
                        //- are not the applied one, and the applied one is the only
                        //- header painted in the accent colour.
                        span.bq-sort(
                            role="button",
                            tabindex="0",
                            :aria-disabled="!canSort",
                            :title="sortTitle(c)",
                            :class="{ 'bq-sort--disabled': !canSort }",
                            @click="toggleSort(c.key)",
                            @keydown.enter.prevent="toggleSort(c.key)",
                            @keydown.space.prevent="toggleSort(c.key)"
                        )
                            | {{ c.name }}
                            span.svgIcon.material-symbols-outlined.bq-sort-arrow(
                                translate="no",
                                aria-hidden="true",
                                :class="{ 'bq-sort-arrow--idle': sortBy !== c.key }"
                            ) {{ sortBy === c.key && !ascending ? "arrow_drop_up" : "arrow_drop_down" }}
                        span.material-symbols-outlined.bq-remove-col(translate="no" @click.stop="removeColumn(c.key)" :class="{ disabled: showTableColumns() <= 1 }" title="Remove column") remove
                        .resizer
                th.fixed.bq-col-toggle-th(style="width:55px;" @mouseenter="showColDropdown" @mouseleave="hideColDropdown" @click.stop="clickColDropdown")
                    span.material-symbols-outlined.bq-icon(translate="no" :class="{ active: colDropdownVisible }" title="Show columns") view_column
                    .bq-col-dropdown(v-show="colDropdownVisible" @click.stop @mouseenter="cancelColHide" @mouseleave="onColDropdownLeave")
                        template(v-for="col in columnList")
                            Checkbox(v-model="col.value", style="display: flex;" :disabled="col.value && showTableColumns() === 1") {{ col.name }}

        template(v-slot:body)
            //- upload status rows (up to 4 concurrent)
            tr.nohover.bq-upload-row(v-for="slot in activeUploadSlots" :key="slot.name")
                td(:colspan="colspan", style="padding: 0")
                    .bq-sticky-info
                        span.material-symbols-outlined.bq-upload-icon(translate="no") cloud_upload
                        | Uploading: /#[span(translate="no") {{ slot.name }}]&nbsp;{{ uploadSlotLabel(slot) }}&nbsp;
                        b ({{ slot.position }}/{{ uploadCount[1] }})

            //- gated (no AI platform / no API key): empty placeholder rows (overlay renders on top)
            template(v-if="!chatReady")
                tr.nohover(v-for="i in resultsPerPage")
                    td(:colspan="colspan", style="padding: 0")

            //- loading state: keep the current folder's "go up" row pinned on
            //- top so the folder you're in stays visible while its contents
            //- reload; the rest are empty rows (bunny overlay renders over the
            //- table). pointer-events are disabled via .bq-table-disabled while
            //- fetching, so the row is display-only until the load settles.
            template(v-else-if="getFileListFetching || !listDisplay")
                tr.nohover.bq-updir-row(
                    v-if="dbCurrentDirectory",
                    :class="{ hoverRow: dbCurrentDirectory }",
                    @click="goUpDir()"
                )
                    td.bq-sticky-check
                        span.material-symbols-outlined.bq-folder-icon(
                            translate="no"
                            :class="{ 'bq-folder-icon--open': !inMediaDir }"
                        ) {{ inMediaDir ? "description" : "folder_open" }}
                    td.left(:colspan="colspan - 1" translate="no")
                        | /{{ dbCurrentDirectory ? displayDir(dbCurrentDirectory) + "/" : "" }}
                tr.nohover(v-for="i in resultsPerPage")
                    td(:colspan="colspan", style="padding: 0")

            //- has data
            template(v-else-if="chatReady")
                //- go up dir row
                tr.nohover.bq-updir-row(
                    v-if="dbCurrentDirectory",
                    :class="{ hoverRow: dbCurrentDirectory }",
                    @click="goUpDir()"
                )
                    td.bq-sticky-check
                        span.material-symbols-outlined.bq-folder-icon(
                            translate="no"
                            :class="{ 'bq-folder-icon--open': !inMediaDir }"
                        ) {{ inMediaDir ? "description" : "folder_open" }}
                    td.left(:colspan="colspan - 1" translate="no")
                        | /{{ dbCurrentDirectory ? displayDir(dbCurrentDirectory) + "/" : "" }}

                tr.hoverRow(
                    v-for="(ns, i) in listDisplay",
                    @click="() => { ns.name[0] === '#' ? setNewDir(ns) : openFile(ns); }",
                    :class="{ 'bq-row-loading': loadingFiles[ns.name] }",
                    :data-track="`dbfile_tb_row`"
                    :data-track-id="ns.name"
                )
                    td.bq-sticky-check(
                        @click.stop="inMediaDir ? null : (checked[ns?.name] ? delete checked[ns?.name] : (checked[ns?.name] = ns))"
                    )
                        span.material-symbols-outlined.bq-upload-icon.bq-spin(
                            translate="no"
                            v-if="loadingFiles[ns.name]"
                        ) directory_sync
                        Checkbox(
                            v-else-if="!inMediaDir",
                            @click.stop,
                            :modelValue="!!checked?.[ns?.name]",
                            @update:modelValue="(value) => { if (value) checked[ns?.name] = ns; else delete checked[ns?.name]; }"
                        )

                    template(v-for="c in columnList")
                        template(v-if="c.value")
                            td.overflow.left(v-if="c.key === 'name' && ns.name[0] == '#'")
                                span.material-symbols-outlined.bq-folder-icon(
                                    translate="no"
                                    style="vertical-align: sub"
                                ) {{ folderIcon(ns.name) }}
                                | &nbsp;
                                span.bq-folder-ellipsis(v-if="folderResolving(ns.name)" translate="no" aria-label="loading")
                                span(v-else translate="no") {{ folderLabel(ns.name) }}
                            td.overflow.left(v-else-if="c.key === 'name'" :class="{ 'bq-name-with-media': hasMedia(ns) }")
                                //- Files carrying extracted media open like a folder.
                                span.material-symbols-outlined.bq-media-enter(
                                    v-if="hasMedia(ns)",
                                    translate="no",
                                    title="Open extracted media",
                                    @click.stop="enterMedia(ns)"
                                ) chevron_right
                                span.material-symbols-outlined.bq-index-badge(
                                    translate="no"
                                    v-if="!inMediaDir && fileIndexState(ns)"
                                    :class="`bq-index-badge--${fileIndexState(ns)}`"
                                    :title="indexBadgeTitle(ns)"
                                ) {{ indexBadgeIcon(ns) }}
                                | #[span(translate="no") {{ ns.name }}]
                            td.overflow(v-else-if="c.key === 'size'") {{ convertBytesToReadableStorage(ns.size) }}
                            td.overflow(v-else-if="c.key === 'upl'") {{ new Date(ns.upl).toLocaleString() }}
                    td

                tr.nohover(
                    v-for="i in Math.max(0, resultsPerPage - (listDisplay?.length || 0))"
                )
                    td(:colspan="colspan")

    //- gate loading overlay (rabbit) while we resolve API-key state
    //- .bq-apikey-overlay(v-if="gateLoading")
    //-     .bq-apikey-overlay-inner
    //-         BunnyLoader(:overlay="false" label="Loading...")
    //- AI platform overlay (matches agent.vue's "Select an AI platform" overlay)
    .bq-apikey-overlay(v-if="!gateLoading && !hasAiPlatform")
        .bq-apikey-overlay-inner
            p.bq-apikey-help Select an AI platform.
            .bq-platform-overlay-options
                button.btn.bq-platform-overlay-btn(
                    v-for="p in platformOptions"
                    :key="p.id"
                    type="button"
                    :disabled="savingPlatform"
                    @click="onPlatformSelect(p.id)"
                )
                    img.bq-apikey-logo(v-if="p.logo" :src="p.logo" :alt="p.label" :class="`bq-apikey-logo--${p.id}`")
                    span {{ p.label }}
    //- API key overlay (matches agent.vue's "Enter API Key" overlay)
    .bq-apikey-overlay(v-if="!gateLoading && hasAiPlatform && !hasAiApiKey")
        .bq-apikey-overlay-inner
            img.bq-apikey-logo(v-if="platformLogo" :src="platformLogo" :alt="platformLabel")
            button.btn(type="button" :disabled="savingApiKey || loadingApiKey" :class="{ 'is-loading-key': loadingApiKey }" @click="openApiKeyModal")
                span(v-if="loadingApiKey") {{ apiKeyLoadingDots }}
                span(v-else) Enter API Key
            p.bq-apikey-help
                span.wordset Get your API key:&nbsp;
                a.bq-link(:href="apiKeyDocsUrl" target="_blank" rel="noopener noreferrer" translate="no") {{ apiKeyDocsUrl }}
    //- drag overlay
    .bq-drag-popup(:class="{ show: dragHere }")
        span.material-symbols-outlined(translate="no" style="font-size: 3rem") cloud_upload
        p Drop files or folders to index

//- pagination
.bq-pagination.bq-desktop-only
    button.bq-page-btn(
        @click="currentPage--",
        :disabled="!chatReady || getFileListFetching || currentPage <= 1 || maxPage <= 0",
        data-track="dbfile_prev_page_icon"
    ) &larr; Prev
    button.bq-page-btn(
        @click="currentPage++",
        :disabled="!chatReady || getFileListFetching || (isCurrentDirEndOfList && (currentPage >= maxPage || !listDisplay.length))",
        data-track="dbfile_next_page_icon"
    ) Next &rarr;

//- mobile file list (infinite scroll)
//- mobile file list (infinite scroll)
.bq-mobile-list(v-if="isMobile", ref="mobileListRef")
    //- gate loading overlay (rabbit) while we resolve API-key state
    .bq-apikey-overlay(v-if="gateLoading")
        .bq-apikey-overlay-inner
            BunnyLoader(:overlay="false" label="Loading...")
    //- AI platform overlay
    .bq-apikey-overlay(v-else-if="!hasAiPlatform")
        .bq-apikey-overlay-inner
            p.bq-apikey-help Select an AI platform.
            .bq-platform-overlay-options
                button.btn.bq-platform-overlay-btn(
                    v-for="p in platformOptions"
                    :key="p.id"
                    type="button"
                    :disabled="savingPlatform"
                    @click="onPlatformSelect(p.id)"
                )
                    img.bq-apikey-logo(v-if="p.logo" :src="p.logo" :alt="p.label" :class="`bq-apikey-logo--${p.id}`")
                    span {{ p.label }}
    //- API key overlay
    .bq-apikey-overlay(v-else-if="hasAiPlatform && !hasAiApiKey")
        .bq-apikey-overlay-inner
            img.bq-apikey-logo(v-if="platformLogo" :src="platformLogo" :alt="platformLabel")
            button.btn(type="button" :disabled="savingApiKey || loadingApiKey" :class="{ 'is-loading-key': loadingApiKey }" @click="openApiKeyModal")
                span(v-if="loadingApiKey") {{ apiKeyLoadingDots }}
                span(v-else) Enter API Key
            p.bq-apikey-help
                span.wordset Get your API key:&nbsp;
                a.bq-link(:href="apiKeyDocsUrl" target="_blank" rel="noopener noreferrer" translate="no") {{ apiKeyDocsUrl }}

    //- status banners (show first active slot; count banner covers overall progress)
    .bq-mobile-status(v-if="isMyUpload")
        .bq-mobile-status-icon
            span.material-symbols-outlined(translate="no") cloud_upload
        .bq-mobile-status-text
            .bq-mobile-status-title Uploading
            .bq-mobile-status-detail(translate="no") {{ activeUploadSlots[0]?.name }} ({{ activeUploadSlots[0]?.position }}/{{ uploadCount[1] }})
        .bq-mobile-status-bar
            .bq-mobile-status-bar-fill(
                :class="{ 'bq-mobile-status-bar-fill--indeterminate': !uploadBytesMoving }"
                :style="uploadBytesMoving ? { width: overallUploadProgress + '%' } : {}"
            )

    //- loading placeholder
    template(
        v-if="getFileListFetching && (!mobileAllItems || mobileAllItems.length === 0)"
    )
        .bq-mobile-placeholder
            span.bq-loader

    //- file items
    template(
        v-else-if="(mobileAllItems && mobileAllItems.length > 0) || dbCurrentDirectory"
    )
        //- go up dir
        .bq-mobile-file-item(@click="mobileGoUp", v-if="dbCurrentDirectory")
            .bq-mobile-file-icon
                span.material-symbols-outlined.bq-folder-icon(
                            translate="no"
                            :class="{ 'bq-folder-icon--open': !inMediaDir }"
                        ) {{ inMediaDir ? "description" : "folder_open" }}
            .bq-mobile-file-info
                .bq-mobile-file-name(translate="no") /{{ dbCurrentDirectory ? displayDir(dbCurrentDirectory) + "/" : "" }}

        //- files and folders
        .bq-mobile-file-item(
            v-for="ns in mobileAllItems",
            :key="ns.name",
            :class="{ 'bq-row-loading': loadingFiles[ns.name] }",
            @click="() => { onMobileTap(ns); }"
        )
            .bq-mobile-file-icon
                span.material-symbols-outlined.bq-upload-icon.bq-spin(
                    translate="no"
                    v-if="loadingFiles[ns.name]"
                ) directory_sync
                span.material-symbols-outlined.bq-folder-icon(
                    translate="no"
                    v-else-if="ns.name[0] === '#'"
                ) {{ folderIcon(ns.name) }}
                //- A file that carries extracted media shows a chevron INSTEAD of its file
                //- icon: a phone row has no room for a separate control, so the icon slot
                //- itself becomes the way in. Tapping it enters; tapping anywhere else on
                //- the row still opens the file.
                span.material-symbols-outlined.bq-media-enter(
                    v-else-if="hasMedia(ns)",
                    translate="no",
                    @click.stop="onMobileEnterMedia(ns)"
                ) chevron_right
                span.material-symbols-outlined.bq-file-icon(translate="no" v-else) description
            .bq-mobile-file-info
                .bq-mobile-file-name
                    span.material-symbols-outlined.bq-index-badge(
                        translate="no"
                        v-if="!inMediaDir && fileIndexState(ns)"
                        :class="`bq-index-badge--${fileIndexState(ns)}`"
                        :title="indexBadgeTitle(ns)"
                    ) {{ indexBadgeIcon(ns) }}
                    span.bq-folder-ellipsis(v-if="ns.name[0] === '#' && folderResolving(ns.name)" translate="no" aria-label="loading")
                    span(v-else translate="no") {{ ns.name[0] === "#" ? folderLabel(ns.name) : ns.name }}
                .bq-mobile-file-size(v-if="ns.name[0] !== '#'") {{ convertBytesToReadableStorage(ns.size) }}
            span.material-symbols-outlined.bq-mobile-file-delete(
                translate="no"
                v-if="ns.name[0] !== '#'",
                @click.stop="checked = { [ns.name]: ns }; deleteSelected = true"
            ) delete
            span.material-symbols-outlined.bq-mobile-file-chevron(
                translate="no"
                v-if="ns.name[0] === '#'"
            ) chevron_right

    //- empty state — tap to upload (only after the first fetch confirms it's empty)
    template(v-else-if="chatReady && !getFileListFetching && hasFetchedOnce")
        .bq-mobile-empty(@click="uploadFileInp.click()")
            span.material-symbols-outlined.bq-mobile-empty-icon(translate="no") note_add
            .bq-mobile-empty-label Tap to upload files

    //- end / loading indicators
    .bq-mobile-end(
        v-if="isCurrentDirEndOfList && !getFileListFetching && mobileAllItems && mobileAllItems.length > 0"
    ) - End of list -
    .bq-mobile-loading(
        v-if="getFileListFetching && mobileAllItems && mobileAllItems.length > 0"
    )
        span.bq-loader

//- modal :: delete selected
Modal(:open="deleteSelected", @close="() => { if (!modalPromise) deleteSelected = false }")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") delete
            span Delete Files
        .bq-modal-delete-body
            p Delete {{ Object.keys(checked).length }} file(s) from database storage?
            p.bq-modal-delete-warn This action cannot be undone.
        .bq-modal-delete-footer
            template(v-if="modalPromise")
                span.bq-loader Deleting
            template(v-else)
                button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                    @click="deleteSelected = false"
                ) Cancel
                button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                    @click="deleteFiles",
                    data-track="dbfile_deleteSelModal_delete"
                ) Delete

//- modal :: reindex selected
Modal(:open="reindexConfirm", @close="() => { if (!reindexing) reindexConfirm = false }")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") manage_search
            span Reindex Files
        .bq-modal-delete-body
            p Send {{ checkedItemCount }} selected item(s) to the AI agent for re-indexing?
            p.bq-modal-delete-warn Files inside selected folders will also be reindexed.
        .bq-modal-delete-footer
            template(v-if="reindexing")
                span.bq-loader Reindexing {{ reindexDone }}/{{ reindexTotal }}
            template(v-else)
                button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                    @click="reindexConfirm = false"
                ) Cancel
                button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                    @click="reindexAllFiles",
                    data-track="dbfile_reindexSelModal_reindex"
                ) Reindex

//- modal :: upload errors
Modal(:open="uploadErrorModal", @close="uploadErrorModal = false")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") error
            span Upload Incomplete
        .bq-modal-delete-body
            p Some files had an error and were not uploaded.
            p.bq-modal-delete-warn {{ failedUploads.length }} file(s) failed:
            .bq-upload-error-list
                .bq-upload-error-group(v-for="(g, i) in uploadErrorReportDisplay" :key="i")
                    p.bq-upload-error-heading {{ g.code ? g.code + ' — ' + g.message : g.message }}
                    ul.bq-upload-error-files
                        li(v-for="(name, j) in g.files" :key="j" translate="no") /{{ name }}
                        li.bq-upload-error-more(v-if="g.moreCount") ...and {{ g.moreCount }} more
        .bq-modal-delete-footer
            button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(@click="uploadErrorModal = false") Close

//- modal :: work from an earlier visit that could not be finished. Survives a
//-          reload, unlike the live batch report above, because it is rebuilt
//-          from the persisted queue rather than from memory.
Modal(:open="unfinishedReport.open", @close="dismissUnfinished")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") error
            span {{ unfinishedReport.failedUploads.length || unfinishedReport.failedIndex.length ? 'Some files did not finish' : 'Some files cannot be auto-resumed' }}
        .bq-modal-delete-body
            p.bq-modal-delete-warn(v-if="unfinishedReport.failedUploads.length")
                | {{ unfinishedReport.failedUploads.length }} file(s) could not be uploaded.
            p.bq-modal-delete-warn(v-if="unfinishedReport.failedIndex.length")
                | {{ unfinishedReport.failedIndex.length }} file(s) were uploaded but could not be set up for AI search, so the agent cannot see them yet.
            template(v-if="unfinishedReport.untracked.count")
                p.bq-modal-delete-warn
                    | {{ unfinishedReport.untracked.count }} file(s) could not be saved for automatic resume, because they were too large to keep a copy of or this browser refused the space. They upload and are indexed normally; only the automatic resume is unavailable for them. If that upload was interrupted, re-add them.
                .bq-upload-error-list
                    ul.bq-upload-error-files
                        li(v-for="(name, j) in unfinishedReport.untracked.names" :key="'u' + j" translate="no") /{{ name }}
            .bq-upload-error-list
                .bq-upload-error-group(v-for="(g, i) in unfinishedReportGroups" :key="i")
                    p.bq-upload-error-heading {{ g.code ? g.code + ': ' + g.message : g.message }}
                    ul.bq-upload-error-files
                        li(v-for="(name, j) in g.files" :key="j" translate="no") /{{ name }}
                        li.bq-upload-error-more(v-if="g.moreCount") ...and {{ g.moreCount }} more
        .bq-modal-delete-footer
            button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                @click="discardUnfinished",
                :disabled="unfinishedReport.busy || null"
            ) Discard
            button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                @click="retryUnfinished",
                :disabled="unfinishedReport.busy || null",
                data-track="dbfile_unfinishedModal_retry"
            ) Retry

//- modal :: an earlier upload did not finish (recovered from the persisted queue)
Modal(:open="resumeModal.open", @close="dismissResume")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") cloud_upload
            span Unfinished upload
        .bq-modal-delete-body
            p An earlier upload to this project did not finish.
            p.bq-modal-delete-warn {{ resumeModal.count }} file(s) were never uploaded.
            p(v-if="resumeModal.unreadable")
                | {{ resumeModal.unreadable }} of them can no longer be read from disk (moved, renamed or edited since) and must be re-selected.
        .bq-modal-delete-footer
            button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                @click="discardResume",
                :disabled="resumeModal.busy || null"
            ) Discard
            button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                @click="doResumeUploads",
                :disabled="resumeModal.busy || !resumeModal.resumable || null"
            ) Resume upload

//- modal :: file already exists — non-dismissible, user must choose
Modal(:open="overwriteModal.open", @close="() => {}")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") file_copy
            span File already exists
        .bq-modal-delete-body
            p A file named “#[span(translate="no") {{ overwriteModal.filename }}]” already exists here.
            p.bq-modal-delete-warn Skip it, keep the existing file and just reindex it, or overwrite it completely?
            label.bq-overwrite-applyall
                input(type="checkbox" v-model="overwriteModal.applyToAll")
                span Apply to all remaining files
        .bq-modal-delete-footer
            button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(@click="chooseOverwrite('skip')") Skip
            button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(@click="chooseOverwrite('reindex')") Reindex
            button.bq-modal-delete-btn.bq-modal-delete-btn--delete(@click="chooseOverwrite('overwrite')") Overwrite

//- Who may read these files once they are indexed. Asked ONCE for the whole
//- upload, BEFORE anything is queued, and only when the project is set to "Ask
//- on every upload": when the project names a group there is nothing to decide
//- and this never opens. It used to ask per file, after that file had already
//- uploaded, so a drop of thirty files uploaded all thirty and then interrogated
//- the user about them one at a time.
//-
//- Batch copy only, because this page has no per-file ask left (agent.vue still
//- does, on its own "chat:" prompt instance, with its own template). A db-side
//- per-file question added later has to branch this copy on accessModal.batch:
//- the count and the Cancel below are both wrong for one already-stored file.
//-
//- Dismissible, unlike the overwrite modal: nothing is queued yet, so "no answer"
//- can still mean "upload nothing" (see cancelAccessGroup).
Modal(:open="accessModal.open", @close="cancelAccessGroup")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") lock
            span Who can read {{ accessBatchSubject }}?
        .bq-modal-delete-body
            p {{ accessBatchQuestion }}
            .bq-access-options
                label.bq-access-option(v-for="o in uploadAccessOptions" :key="o.value")
                    input(type="radio" name="bq-upload-access" :value="o.value" v-model="accessModal.choice")
                    span.bq-access-option-label {{ o.label }}
                    span.bq-access-option-hint {{ o.hint }}
            p.bq-modal-delete-warn A file that is already here keeps the answer it was given the first time, so replacing or reindexing one does not change who can read it.
        .bq-modal-delete-footer
            button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(@click="cancelAccessGroup") Cancel
            button.bq-modal-delete-btn.bq-modal-delete-btn--delete(@click="chooseAccessGroup(accessModal.choice)") Upload

//- modal :: enter AI api key
Modal(:open="apiKeyModalOpen" @close="() => { if (!savingApiKey) apiKeyModalOpen = false }")
    .bq-modal-wrap
        .bq-modal-close(@click="apiKeyModalOpen = false" :class="{ disabled: savingApiKey }") &times;
        form.bq-modal-step(@submit.prevent="saveApiKey")
            h2 API Key
            p.bq-modal-desc Enter your {{ platformLabel }} API key.
            textarea.bq-modal-textarea(
                ref="apiKeyInputEl"
                :disabled="savingApiKey || null"
                placeholder="sk-..."
                :value="apiKeyInput"
                rows="3"
                @input="e => apiKeyInput = e.target.value"
            )
            button.btn(
                type="submit"
                :class="{ 'bq-btn--loading': savingApiKey }"
                :disabled="savingApiKey || !apiKeyInput.trim()"
            )
                span.bq-loader(v-if="savingApiKey")
                template(v-else) Save
</template>

<script setup lang="ts">
import { reactive, ref, computed, watch, nextTick, onMounted, onUnmounted } from "vue";
import { SkapiError } from "skapi-js";
import { skapi } from "@/main";
import { user } from "@/code/user";
import { currentService, aiApiKeyCache, aiApiKeyInflight, aiModelCache, agentHistoryRefreshTrigger, dbFileRefreshTrigger, dbFileRefreshLastSeen, serviceClientSecrets, saveAiApiKeyPrivately, loadAiApiKeyPrivately, collaboratorEmailCache, isCollaboratorFolderId, resolveCollaboratorEmail } from "@/views/project-list";
import { convertBytesToReadableStorage } from "@/code/service-spec";
import { aiClientSecretGrp } from "@/code/service";
import {
    dbServiceFolders,
    uploadFiles,
    onDrop,
    dbUploadCountFor,
    dbUploadSlotsFor,
    dbUploadResultFor,
    urlCache,
    dbIndexedPaths,
    dbUnindexedChecked,
    DB_UNINDEXED_TTL_MS,
    chatIndexVerdicts,
    CHAT_VERDICT_TTL_MS,
    sweepIndexMarkers,
    invalidateDoneMarkerSweep,
    dbMediaIndex,
    dbMediaLoading,
    enqueueResumedUploads,
    inFlightUploadIds,
    type DbUploadFailure,
    type UploadBatchInfo,
} from "@/views/service/file";
import {
    listPendingUploads,
    unpersistPendingUpload,
    unpersistPendingUploads,
    updatePersistedUpload,
    isFileStillReadable,
    isRetriableUploadError,
    uploadRetryDelayMs,
    sleep,
    phaseOf,
    beginIndexSetup,
    endIndexSetup,
    isIndexSetupInFlight,
    leaseIndexSetup,
    releaseIndexSetupLease,
    runBounded,
    INDEX_SETUP_MAX_ATTEMPTS,
    readUntrackedUploads,
    clearUntrackedUploads,
    type PersistedUpload,
    type UntrackedUploads,
} from "@/views/service/upload_durability";
import { notifyAgentSaveAttachment, deleteFileIndexRecord, ensureFileIndexRecord, readFileIndexAccessGroup, bgTaskQueue, groupAttachmentFailures, chatSession, fetchLiveIndexingKeys, indexDoneUniqueId, RUN_RECORD_WORKING_STALE_MS, type AttachmentSaveInfo, type AttachmentFailureGroup } from "@/code/ai_agent";
import { useOverwritePrompt } from "@/views/service/useOverwritePrompt";
import { useAccessGroupPrompt } from "@/views/service/useAccessGroupPrompt";
import { UPLOAD_ACCESS_OPTIONS, UPLOAD_ACCESS_LABELS, projectUploadAccessGroup, projectAsksUploadAccess, primeProjectSettings, readyProjectSettings, type UploadAccessGroup } from "@/code/access_group";
import mime from "mime";
import Table from "@/components/table.vue";
import Modal from "@/components/modal.vue";
import Pager from "@/code/pager";
import Checkbox from "@/components/checkbox.vue";
import BunnyLoader from "@/components/bunnyLoader.vue";
import { removeFullScreenLoader } from "@/components/jsComponents";
import chatgptLogo from "@/assets/img/logo/ChatGPT-Logo.png";
import claudeLogo from "@/assets/img/logo/claude-ai-symbol.svg";

const { overwriteModal, resetOverwriteBatch, promptOverwrite, chooseOverwrite } = useOverwritePrompt("db:" + (currentService.value?.id || ""));
// promptAccessGroup (the per-file question) is deliberately NOT taken here: this
// page asks once per batch, up front, and pulling the per-file one into scope is
// how a later edit quietly puts a modal back in front of a file that has already
// uploaded. agent.vue still uses it, on its own "chat:" instance.
const { accessModal, resetAccessGroupBatch, batchAccessGroup, promptAccessGroupForBatch, chooseAccessGroup, cancelAccessGroup, releaseAccessGroupPrompt } = useAccessGroupPrompt("db:" + (currentService.value?.id || ""));
const uploadAccessOptions = UPLOAD_ACCESS_OPTIONS;
const uploadAccessLabels = UPLOAD_ACCESS_LABELS;

// Copy for the batch question, which is asked once about N files and has to read
// correctly for one file as well as for thirty. Spelled out rather than written
// as "file(s)": this is the sentence that decides who can read the user's data.
const accessBatchSubject = computed(() =>
    accessModal.count === 1 ? "this file" : `these ${accessModal.count} files`
);
const accessBatchQuestion = computed(() =>
    accessModal.count === 1
        ? "Choose who can ask questions about this file once it is indexed."
        : `Choose who can ask questions about these ${accessModal.count} files once they are indexed.`
);

/**
 * This batch's answer, stamped onto the individual File objects that batch is
 * about to queue.
 *
 * The prompt module remembers ONE answer per project, and that is not enough on
 * its own: nothing stops a user from adding a second batch while the first is
 * still uploading, and every entry point resets the remembered answer before
 * asking its own question. So the first batch's remaining files would read null
 * and then whatever the second batch answered. For a user who said "Only me" and
 * then dropped a public batch, that is a silent declassification of the files
 * they had just marked private, which is the one outcome this whole setting
 * exists to prevent. Each file therefore carries its own batch's answer.
 *
 * Keyed by the File object because that is what survives the trip: file.ts
 * queues the very objects it hands to the batch hook, and gives each one back to
 * onItemUploaded (`let f = item.file`). A WeakMap, so the entries go when the
 * Files do: a 10k-file drop must not leave 10k of them behind.
 *
 * Nothing that did not come through onBeforeBatch is in here: a resumed batch, or
 * a repair pass after a reload, whose Files are rebuilt from the persisted row or
 * absent entirely. Those fall back to the remembered answer, then to the project
 * default. See resolveUploadAccessGroup.
 */
const uploadAccessGroupByFile = new WeakMap<File, UploadAccessGroup>();

/**
 * The same answer, keyed by PERSIST ID rather than by File.
 *
 * A resumed or retried upload comes back out of IndexedDB as a NEW File object, so
 * the WeakMap above cannot recognise it and the batch answer is lost exactly when it
 * matters most: a project set to 'ask' would index the rest of an interrupted batch at
 * the default, though the user answered "Only me", silently widening every file the
 * interruption left behind. The persisted row carries the answer (see
 * PersistedUpload.accessGroup); this is where the resume offer hands it back.
 */
const uploadAccessGroupByPersistId = new Map<string, UploadAccessGroup>();

/**
 * Who may read what is indexed out of this file: the project default, or the
 * answer this file's batch gave before it was uploaded. Resolved ONCE per file,
 * right before the src:: record is written, and the same value is then carried
 * into the indexing request so the agent's own records land in the same access
 * group.
 *
 * ASKS NOTHING. It used to open the modal right here, which is per file and
 * after that file's bytes are already stored: thirty files meant thirty
 * questions, all of them too late to act on. The question is now asked once,
 * before anything is queued (see dbUploadOptions.onBeforeBatch), and this only
 * spends the answer.
 *
 * IT DOES await, on the project's settings record. The setting is no longer a
 * field on the service object this page already holds (see @/code/access_group),
 * and the sync accessors answer with the default until the record has been
 * fetched. This is the call whose answer is WRITTEN onto the src:: record and
 * handed to the indexing prompt, so reading an unsettled cache here is how a
 * file lands in the wrong group. Normally free: the mount primed it, and a
 * repair running long after the page opened finds it settled.
 *
 * TAKES THE SERVICE ID, not the live service: an index setup can run for a
 * project other than the one on screen (an upload outlives the page, and a
 * repair rebuilds its target from a persisted row).
 */
const resolveUploadAccessGroup = async (service: string, stamped?: UploadAccessGroup | null): Promise<UploadAccessGroup> => {
    await readyProjectSettings(service);
    if (!projectAsksUploadAccess(service)) {
        return projectUploadAccessGroup(service);
    }
    // DELIBERATELY DOES NOT CONSULT batchAccessGroup(). Every file of the CURRENT
    // batch carries its own answer, stamped onto the File when the question was
    // answered, so the live remembered value can only ever be read here on behalf of
    // a file from some OTHER batch: a resume after a reload, or a repair of an index
    // setup left over from a previous session. Handing those a stranger's answer is
    // not a fallback, it is a declassification. Concretely: answer "Only me" for
    // batch A, one file's index dispatch fails and its row is left for repair, then
    // answer "Public" for batch B, and the repair would write batch A's private file
    // at group 0, readable by anonymous visitors, along with every record the agent
    // extracts from it.
    //
    // So a file with no answer of its own takes the value the modal itself opens on,
    // 'authorized'. That is what clicking Upload without touching the radios
    // produces, and it is the group every record written before this setting existed
    // was hardcoded to. It is never wider than what the user last chose, and it never
    // silently applies a choice they made about different files.
    return stamped || projectUploadAccessGroup(service);
};

let dbstore = computed(() => "db:" + currentService.value.id);

// Only treat an upload as belonging to this page when it targets the
// db file store, so a hosting-page upload doesn't display here.
// Upload state of THIS project, not of whatever upload happens to be running.
// Db uploads are queued and counted per project (see file.ts dbUploadStateFor),
// so a batch started in another project neither appears in these rows nor holds
// this project's files back. Read once: the page is mounted for one project (a
// project switch goes through the project list, which unmounts it).
const uploadServiceId = currentService.value?.id || "";
const dbUploadSlots = dbUploadSlotsFor(uploadServiceId);
const uploadCount = dbUploadCountFor(uploadServiceId);
const dbUploadResult = dbUploadResultFor(uploadServiceId);

const isMyUpload = computed(() => dbUploadSlots.some(s => !!s.name));
const activeUploadSlots = computed(() => dbUploadSlots.filter(s => !!s.name));

// Upload-failure summary modal. uploadFiles records each failed file plus its
// cause (code/message) as it goes (without aborting the batch); when the batch
// settles, file.ts bumps dbUploadResult.token and we surface the failures here,
// grouped by cause so the user sees WHY each file failed — the same report
// agent.vue's chatbox shows for failed attachments.
const uploadErrorModal = ref(false);
const failedUploads = ref<DbUploadFailure[]>([]);
// Failed files grouped by (code, message), reusing the shared engine helper so
// the display matches agent.vue's upload-error report exactly.
const uploadErrorReport = computed<AttachmentFailureGroup[]>(() =>
    groupAttachmentFailures(
        failedUploads.value.map((f) => ({
            name: f.name,
            status: "error",
            errorCode: f.code,
            errorDetail: f.message,
        }))
    )
);
// Cap how many file names each group renders in the modal: a mass failure (e.g.
// auth expiry mid-batch) can fail all 10k files under one cause, and mounting one
// <li> per file would freeze the tab on top of the failed upload. Show a sample
// plus an "and N more" count.
const MAX_ERROR_FILES_SHOWN = 50;
const uploadErrorReportDisplay = computed(() =>
    uploadErrorReport.value.map((g) => ({
        code: g.code,
        message: g.message,
        files: g.files.slice(0, MAX_ERROR_FILES_SHOWN),
        moreCount: Math.max(0, g.files.length - MAX_ERROR_FILES_SHOWN),
    }))
);
// Is there anything real to draw yet? True once a file has settled OR an
// in-flight file has reported byte progress. Only before both is the batch
// purely in its get-signed-url round trip, which reports nothing, and only then
// does the bar go indeterminate (barber pole).
//
// The settled-count half is not redundant: a slot is re-armed with a null
// progress for its NEXT file, so mid-batch there are moments where every active
// slot is preparing. Keying on slot progress alone would drop a batch that is
// genuinely half done back to a barber pole once per file.
const uploadBytesMoving = computed(() =>
    uploadCount[0] > 0 || activeUploadSlots.value.some((s) => s.progress != null)
);

// Overall progress: files already settled, plus the fraction of each in-flight
// file. Previously completed/total alone, which never reflected bytes at all:
// a single-file upload sat at 0% for the whole transfer and then jumped to 100.
const overallUploadProgress = computed(() => {
    const total = uploadCount[1];
    if (total <= 0) return 0;
    const inFlight = activeUploadSlots.value.reduce(
        (sum, s) => sum + (s.progress || 0) / 100,
        0
    );
    return Math.min(
        100,
        Math.floor(((uploadCount[0] + inFlight) / total) * 100)
    );
});

// Byte readout for one in-flight slot, or "Preparing" while its signed-url round
// trip is still in flight and there is nothing to count yet.
const uploadSlotLabel = (slot: { progress: number | null; fileSize: number }) =>
    slot.progress == null
        ? "Preparing"
        : convertBytesToReadableStorage(
              Math.floor((slot.fileSize * slot.progress) / 100)
          ) +
          "/" +
          convertBytesToReadableStorage(slot.fileSize);

let loadingFiles: any = reactive({});

let openFile = async (ns: any) => {
    if (loadingFiles[ns.name]) return;

    let filePath = ns.path + "/" + ns.name;
    let cached = urlCache[filePath];

    // reuse cache if it hasn't expired yet (with 60s buffer)
    if (cached && cached.expiresAt > Date.now() + 60000) {
        window.open(cached.url, "_blank");
        return;
    }

    loadingFiles[ns.name] = true;
    try {
        let result = await currentService.value.getTemporaryUrl({
            request: "get-db",
            path: filePath.split("/").slice(1).join("/"), // remove leading '!' if present
            expires: 3600,
        });

        let url = typeof result === "string" ? result : result.url;
        urlCache[filePath] = { url, expiresAt: Date.now() + 3600 * 1000 };
        window.open(url, "_blank");
    } finally {
        delete loadingFiles[ns.name];
    }
};

let downloading = ref(false);

let downloadChecked = async () => {
    if (downloading.value) return;
    let files = Object.keys(checked.value)
        .map((name) => listDisplay.value.find((v: any) => v.name === name))
        .filter((ns: any) => ns && ns.name);
    if (!files.length) return;

    downloading.value = true;
    checked.value = {};

    for (let ns of files as any[]) {
        loadingFiles[ns.name] = true;
    }

    try {
        for (let ns of files as any[]) {
            let filePath = ns.path + "/" + ns.name;
            let cached = urlCache[filePath];
            let url: string;

            if (cached && cached.expiresAt > Date.now() + 60000) {
                url = cached.url;
            } else {
                let isFolder = ns.name[0] === "#";
                let result = await currentService.value.getTemporaryUrl({
                    request: isFolder ? "get-db-zip" : "get-db",
                    path: filePath.split("/").slice(1).join("/"),
                    expires: 3600,
                    contentType: "application/octet-stream",
                });
                url = typeof result === "string" ? result : result.url;
                urlCache[filePath] = { url, expiresAt: Date.now() + 3600 * 1000 };
            }

            delete loadingFiles[ns.name];

            let a = document.createElement("a");
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // wait between downloads so browser doesn't cancel
            if (files.indexOf(ns) < files.length - 1) {
                await new Promise((r) => window.setTimeout(r, 500));
            }
        }
    } finally {
        for (let ns of files as any[]) {
            delete loadingFiles[ns.name];
        }
        downloading.value = false;
    }
};

let folders: {
    [key: string | "!"]: {
        pager: Pager;
        endOfList: boolean;
    };
} = {}; // cache folders

let dbCurrentDirectory = ref("");

let service_should_be_disabled = computed(() => {
    return (
        currentService.value?.service?.active < 0 ||
        user?.email_verified === false
    );
});

// AI platform + API-key gate (mirrors agent.vue). The file list is only
// fetched/initialized once BOTH a platform is set and a valid API key is
// available for it. Upload UI is gated on the same `chatReady` flag.
type PlatformOption = { id: "claude" | "openai"; label: string; logo: string };
// Same order as agent.vue: ChatGPT first, so the picker reads ChatGPT-default.
const platformOptions: PlatformOption[] = [
    { id: "openai", label: "ChatGPT", logo: chatgptLogo },
    { id: "claude", label: "Claude", logo: claudeLogo },
];
const savingPlatform = ref(false);
const hasAiApiKey = ref(false);
// True while we're resolving the API-key state for the current platform
// (either at mount, on platform-switch, or after saving a new key). While
// this is true the rest of the overlays stay hidden and a rabbit loader
// renders so we don't flash "Enter API Key" before the cache lookup /
// `listClientSecrets` resolves. Start `true` on mount when a platform is
// already configured so the rabbit shows immediately while we resolve.
const gateLoading = ref(false);
let gateRefreshToken = 0;

const parseAiAgent = (value: string | null | undefined) => {
    const raw = (value || "").trim();
    const [platformRaw] = raw.includes("#") ? raw.split("#") : [raw, ""];
    const platform = platformRaw === "claude" || platformRaw === "openai"
        ? (platformRaw as "claude" | "openai")
        : null;
    return { platform, hasPlatform: !!platform };
};

const hasAiPlatform = computed(() => parseAiAgent(currentService.value?.service?.ai_agent).hasPlatform);
const selectedAiPlatform = computed<"claude" | "openai" | null>(() => parseAiAgent(currentService.value?.service?.ai_agent).platform);

const chatReady = computed(() => hasAiPlatform.value && hasAiApiKey.value);

const platformLabel = computed(() => {
    if (selectedAiPlatform.value === "claude") return "Claude";
    if (selectedAiPlatform.value === "openai") return "ChatGPT";
    return "AI";
});

const platformLogo = computed(() => {
    if (selectedAiPlatform.value === "claude") return claudeLogo;
    if (selectedAiPlatform.value === "openai") return chatgptLogo;
    return "";
});

const apiKeyDocsUrl = computed(() => {
    if (selectedAiPlatform.value === "claude") return "https://platform.claude.com";
    if (selectedAiPlatform.value === "openai") return "https://platform.openai.com/";
    return "";
});

// Resolve whether a usable API key exists for the current platform. Mirrors
// agent.vue's refreshGate() but trimmed to just the key-existence check —
// we don't need chat history / model loading here.
const refreshApiKey = async () => {
    const token = ++gateRefreshToken;
    const platform = selectedAiPlatform.value;
    if (!platform || !currentService.value) {
        hasAiApiKey.value = false;
        gateLoading.value = false;
        return;
    }
    gateLoading.value = true;
    const serviceId = currentService.value.id;

    // 1) lightweight cache
    if (aiApiKeyCache[serviceId]?.[platform]) {
        hasAiApiKey.value = true;
        gateLoading.value = false;
        return;
    }

    // 2) shared client-secrets pager
    const pager = serviceClientSecrets[serviceId];
    if (pager?.list?.[platform]?.client_secret) {
        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [platform]: pager.list[platform].client_secret,
        };
        hasAiApiKey.value = true;
        gateLoading.value = false;
        return;
    }

    // 2.5) the visit-time prefetch (main.vue run) may already be fetching this
    // key — await the shared request instead of firing a duplicate (same as
    // agent.vue's refreshGate).
    const inflight = aiApiKeyInflight[serviceId + "#" + platform];
    if (inflight) {
        try { await inflight; } catch { /* prefetch is best-effort */ }
        if (token !== gateRefreshToken) return;
        if (aiApiKeyCache[serviceId]?.[platform]) {
            hasAiApiKey.value = true;
            gateLoading.value = false;
            return;
        }
    }

    // 3) authoritative server lookup
    try {
        const result = await currentService.value.listClientSecrets(false, platform);
        if (token !== gateRefreshToken) return;
        const match = result?.list?.find((s: any) => s.id === platform);
        if (match?.key && typeof match.key === "string" && match.key.trim()) {
            aiApiKeyCache[serviceId] = {
                ...(aiApiKeyCache[serviceId] || {}),
                [platform]: match.key,
            };
            hasAiApiKey.value = true;
        } else {
            hasAiApiKey.value = false;
        }
    } catch (err) {
        if (token === gateRefreshToken) {
            console.error("Failed to look up AI API key", err);
            hasAiApiKey.value = false;
        }
    } finally {
        if (token === gateRefreshToken) gateLoading.value = false;
    }
};

const onPlatformSelect = async (platform: "claude" | "openai") => {
    if (!platform || savingPlatform.value) return;
    savingPlatform.value = true;
    gateLoading.value = true;
    try {
        await currentService.value.setServiceOption({ ai_agent: platform });
        await refreshApiKey();
    } catch (err) {
        console.error("Failed to update AI platform", err);
    } finally {
        savingPlatform.value = false;
    }
};

// API-key modal (mirrors agent.vue saveApiKey: registerClientSecret →
// setServiceOption(ai_agent) → refresh the local key cache, then re-run
// the gate so the upload UI unlocks).
const apiKeyModalOpen = ref(false);
const apiKeyInput = ref("");
const apiKeyInputEl = ref<HTMLTextAreaElement | null>(null);
const savingApiKey = ref(false);
const loadingApiKey = ref(false);
const apiKeyLoadingDots = ref(".");
let apiKeyLoadingDotsTimer: ReturnType<typeof setInterval> | null = null;
const startApiKeyDots = () => {
    if (apiKeyLoadingDotsTimer) return;
    let n = 0;
    apiKeyLoadingDots.value = ".";
    apiKeyLoadingDotsTimer = setInterval(() => {
        n = (n + 1) % 3;
        apiKeyLoadingDots.value = ".".repeat(n + 1);
    }, 350);
};
const stopApiKeyDots = () => {
    if (apiKeyLoadingDotsTimer) {
        clearInterval(apiKeyLoadingDotsTimer);
        apiKeyLoadingDotsTimer = null;
    }
};

const openApiKeyModal = async () => {
    if (!hasAiPlatform.value || savingApiKey.value || loadingApiKey.value) return;
    const platform = selectedAiPlatform.value;
    const serviceId = currentService.value?.id;
    const cachedKey =
        (platform === "claude" || platform === "openai") && serviceId
            ? aiApiKeyCache[serviceId]?.[platform] ||
              serviceClientSecrets[serviceId]?.list?.[platform]?.client_secret ||
              ""
            : "";
    let prefill = cachedKey || "";
    if (!prefill && (platform === "claude" || platform === "openai")) {
        loadingApiKey.value = true;
        startApiKeyDots();
        try {
            prefill = (await loadAiApiKeyPrivately(platform)) || "";
        } finally {
            loadingApiKey.value = false;
            stopApiKeyDots();
        }
    }
    apiKeyInput.value = prefill;
    apiKeyModalOpen.value = true;
    nextTick(() => {
        apiKeyInputEl.value?.focus();
    });
};

const saveApiKey = async () => {
    const platform = selectedAiPlatform.value;
    if (platform !== "claude" && platform !== "openai") return;
    const key = apiKeyInput.value.trim();
    if (!key) return;

    savingApiKey.value = true;
    try {
        const serviceId = currentService.value.id;
        const hadExistingKey = !!(
            aiApiKeyCache[serviceId]?.[platform] ||
            serviceClientSecrets[serviceId]?.list?.[platform]?.client_secret
        );
        await currentService.value.registerClientSecret({
            id: platform,
            key,
            // Tracks "Allow anonymous users"; see aiClientSecretGrp.
            grp: aiClientSecretGrp(currentService.value),
            req: hadExistingKey ? "update" : "create",
        });
        await currentService.value.setServiceOption({ ai_agent: platform });

        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [platform]: key,
        };

        // Also persist the key as a private record so we can recover the
        // last value on a fresh session without going through the
        // client-secret store.
        void saveAiApiKeyPrivately(serviceId, platform, key);

        const pager = serviceClientSecrets[serviceId];
        if (pager) {
            const mapped = {
                name: platform,
                client_secret: key,
                locked: true,
            };
            if (pager.list?.[platform]) {
                await pager.editItem(mapped);
            } else {
                await pager.insertItems([mapped]);
            }
        }

        apiKeyModalOpen.value = false;
        apiKeyInput.value = "";

        // Drop any stale model cache so the agent page refetches against
        // the new key when it next loads.
        delete aiModelCache[platform];

        await refreshApiKey();
    } catch (err) {
        console.error("Failed to save API key", err);
    } finally {
        savingApiKey.value = false;
    }
};

// fileinputs
let uploadFileInp = ref(null);
let uploadFolderInp = ref(null);

let dragHere = ref(false);
let modalPromise = ref(false);

// column dropdown
let columnList = reactive([
    { name: "Filename", key: "name", value: true },
    { name: "Size", key: "size", value: true },
    { name: "Uploaded", key: "upl", value: true },
]);
let colspan = computed(() => {
    return 2 + columnList.filter((c) => c.value).length; // checkbox + settings
});
const showTableColumns = () => columnList.filter((c) => c.value).length;

const colDropdownVisible = ref(false);
let colHideTimeout: ReturnType<typeof setTimeout> | null = null;
let colClickClosedAt = 0;
const removeColumn = (key: string) => {
    if (showTableColumns() <= 1) return;
    let col = columnList.find((c: any) => c.key === key);
    if (col) col.value = false;
};
const clickColDropdown = () => {
    if (colHideTimeout) { clearTimeout(colHideTimeout); colHideTimeout = null; }
    if (colDropdownVisible.value) {
        colDropdownVisible.value = false;
        colClickClosedAt = Date.now();
    } else {
        colDropdownVisible.value = true;
    }
};
const showColDropdown = () => {
    if (Date.now() - colClickClosedAt < 300) return;
    if (colHideTimeout) { clearTimeout(colHideTimeout); colHideTimeout = null; }
    colDropdownVisible.value = true;
};
const hideColDropdown = () => {
    colHideTimeout = setTimeout(() => { colDropdownVisible.value = false; }, 240);
};
const cancelColHide = () => {
    if (colHideTimeout) { clearTimeout(colHideTimeout); colHideTimeout = null; }
};
const onColDropdownLeave = (e: MouseEvent) => {
    const th = (e.currentTarget as HTMLElement)?.closest('.bq-col-toggle-th');
    if (th && th.contains(e.relatedTarget as Node)) return;
    colHideTimeout = setTimeout(() => { colDropdownVisible.value = false; }, 240);
};

const tableRef = ref<HTMLElement | null>(null);
let tableKey = ref(0);
let columnListInitialized = false;
let prevVisibleColCount = 0;
watch(
    columnList,
    (nv) => {
        let visibleCount = nv.filter((c) => c.value).length;
        if (columnListInitialized && visibleCount > prevVisibleColCount) {
            nextTick(() => {
                let wrap = tableRef.value;
                if (wrap) {
                    let scrollEl = wrap.querySelector('.tableWrap');
                    if (scrollEl) scrollEl.scrollLeft = scrollEl.scrollWidth;
                }
            });
        }
        prevVisibleColCount = visibleCount;
        columnListInitialized = true;
        // remount the table so every column returns to its initial width
        // (users.vue does the same; without this, stale inline widths from
        // resizing/stretching survive the toggle and create junk x-scroll)
        tableKey.value++;
    },
    { immediate: true }
);

// ─── extracted media: path helpers ───────────────────────────────────────────
// Declared HERE, above their first use in dbUploadOptions, rather than beside the
// rest of the media code further down.
const MEDIA_ROOT = "__MEDIA__";

const isMediaDir = (dir: string) =>
    dir === MEDIA_ROOT || dir.startsWith(MEDIA_ROOT + "/");

/** True while browsing a file's extracted media rather than a real folder. */
const inMediaDir = computed(() => isMediaDir(dbCurrentDirectory.value || ""));

/** The folder a media view belongs to: __MEDIA__/invoices/report.xlsx -> invoices */
const mediaParentDir = (dir: string) =>
    dir.slice(MEDIA_ROOT.length + 1).split("/").slice(0, -1).join("/");

let dbUploadOptions = computed(() => ({
    target: "db" as const,
    // Inside a file's extracted media there is no sensible "here" to upload into:
    // __MEDIA__ is hidden from every listing, so a file dropped there would be
    // invisible the moment the upload finished. Send it to the folder the source
    // file itself lives in.
    currentDir: inMediaDir.value
        ? mediaParentDir(dbCurrentDirectory.value || "")
        : dbCurrentDirectory.value,
    foldersRef: dbServiceFolders,
    storeKey: dbstore.value,
    onItemUploaded: onUploadedCollect,
    // Existing-file conflict resolver: prompt per file (reindex vs overwrite).
    onBeforeItem: (info: { file: File }) => promptOverwrite(info.file.name),
    // Who may read what gets indexed out of this upload: ONE question, asked
    // before a single file is queued, answered once for the whole batch. This
    // used to be asked per file from inside the index setup, which runs AFTER
    // that file has uploaded, so a drop of thirty files uploaded all thirty and
    // then interrogated the user about them one at a time.
    onBeforeBatch: async (info: UploadBatchInfo) => {
        // Nothing was dropped that resolved to a file (an empty folder is the
        // usual way), so there is nothing to ask about and nothing to queue.
        // Without this the modal opens on "these 0 files".
        if (!info.files.length) return true;
        // Settle the settings record before deciding whether to ask. The sync
        // accessors answer with the default until it is fetched, so on a project
        // set to "Ask every time" a straight read would silently skip the
        // question for the first batch after a page load and index the whole
        // drop at 'authorized'. Normally free (the mount primed it), and it never
        // rejects, so a drop can never be blocked by this.
        const service = currentService.value?.id || "";
        await readyProjectSettings(service);
        // The project already names a group, so there is nothing to decide: this
        // returns without opening anything, and the batch is queued now rather
        // than whenever a user gets round to answering a question they were
        // never meant to see.
        if (!projectAsksUploadAccess(service)) return true;
        // Opens on the value an unset project would have used, so the common
        // answer is one click away.
        const picked = await promptAccessGroupForBatch(
            info.files.length,
            projectUploadAccessGroup(service),
        );
        // Dismissed. Null, and file.ts cancels the batch on any falsy answer that
        // is not undefined: nothing is queued, no bytes move, no counter is
        // touched, and it settles the caller's callback itself so the page comes
        // out of its uploading state.
        if (!picked) return false;
        // STAMPED PER FILE, not just remembered. The remembered answer is one
        // slot per project and the next batch resets it before asking its own
        // question, so a second batch added while this one is still uploading
        // would otherwise hand this batch's remaining files the wrong answer.
        // See uploadAccessGroupByFile.
        for (const f of info.files) uploadAccessGroupByFile.set(f, picked);
        return true;
    },
}));
const ATTACHMENT_NOTIFY_URL_EXPIRES_SECONDS = 60 * 10; // 10m signed URL
// Index setups repaired at once. The dispatch is serialized downstream anyway
// (skapi runs queued requests through a per-queue pass at batchSize 1), so a
// larger number would not go faster; it would only park more chains in memory,
// which is the shape that has run this page out of memory before.
const INDEX_SETUP_CONCURRENCY = 4;

/**
 * Everything the index setup needs, and nothing that only a LIVE upload has.
 *
 * A repair running after a reload rebuilds this from the persisted row, where
 * there is no File left to read (the blob is dropped once the bytes are stored).
 * So the setup is written against metadata, never against the file itself.
 */
type IndexSetupTarget = {
    serviceId: string;
    storagePath: string;
    name: string;
    mime?: string;
    size?: number;
    reindexOnly?: boolean;
    overwrote?: boolean;
    previousSize?: number;
    /** What THIS file's batch answered up front, for a project set to 'ask'.
     *  Read off the File in onUploadedCollect and carried here because the
     *  dispatch itself has no File to look it up with: a repair rebuilds this
     *  target from a persisted row, where the blob is long gone. Absent means
     *  "no answer of its own", which resolveUploadAccessGroup handles. */
    batchAccessGroup?: UploadAccessGroup;
};

/** The server's own words where there are any, so a report names the real cause
 *  rather than "something went wrong". */
const indexSetupErrorOf = (err: any) => ({
    code: (err && (err.code || err?.body?.code)) || "",
    message:
        (err && (err.message || err?.body?.message)) ||
        (typeof err === "string" ? err : "") ||
        "Indexing could not be requested.",
});

/**
 * Get one file's indexing dispatched. Throws if it could not be.
 *
 * Returns 'skipped' for the cases where there is deliberately nothing to do:
 * the project has no agent, or another run already owns this file. Those are
 * successes as far as the durable row is concerned, and it is closed out.
 */
async function dispatchIndexSetup(t: IndexSetupTarget): Promise<"dispatched" | "skipped" | "deferred"> {
    const svc = currentService.value;
    // An upload hook, and a bounded repair pass, both outlive a project switch.
    // Writing one project's index records against another's service object is the
    // cross-project leak all over again, so this stops. But it is NOT a skip:
    // nothing was dispatched, so the durable row has to survive for the next
    // visit to this project. Reporting it as done here is what would delete the
    // record of every remaining file the moment the user navigated away.
    if (!svc || svc.id !== t.serviceId) return "deferred";

    const raw = (svc.service?.ai_agent || "").trim();
    if (!raw) return "skipped";
    const [platformRaw, modelRaw] = raw.includes("#") ? raw.split("#") : [raw, ""];
    const platform = (platformRaw === "claude" || platformRaw === "openai")
        ? (platformRaw as "claude" | "openai")
        : null;
    if (!platform) return "skipped";

    const serviceId = t.serviceId;
    const tu = await svc.getTemporaryUrl({
        request: "get-db",
        path: t.storagePath,
        expires: ATTACHMENT_NOTIFY_URL_EXPIRES_SECONDS,
        generate_temporary_cdn_url: true,
    });
    const url = typeof tu === "string" ? tu : (tu as any)?.url;
    // Not a soft exit: with no URL there is no indexing request to make, and
    // returning quietly here is what used to leave the file stored, un-indexed
    // and badged as indexed. Raise it so the row is retried and then reported.
    if (!url) throw new Error("Could not mint a download URL for this file.");

    const saveInfo: AttachmentSaveInfo = {
        platform,
        model: modelRaw || undefined,
        service: serviceId,
        publicProjectId: svc.service?.projectId || undefined,
        owner: svc.owner,
        // Queue base — must be the same one the chatbox's turns use, or the
        // backend runs this indexing pass in parallel with them instead of
        // ahead of them. See AttachmentSaveInfo.userId.
        userId: user?.user_id || serviceId,
        serviceName: svc.service?.name,
        serviceDescription: svc.service?.description,
        attachment: {
            name: t.name,
            storagePath: t.storagePath,
            mime: t.mime || mime.getType(t.name) || undefined,
            size: t.size,
            url,
        },
    };

    // Delete-then-repost: on an explicit Reindex (reindexOnly) or an
    // Overwrite of an existing same-path file, clear the stale
    // "src::<storagePath>" record first — the skapi backend cascades to its
    // reference-linked children — so re-indexing REPLACES rather than
    // duplicates. Genuinely new files skip this.
    //
    // `overwrote` is the authoritative overwrite signal (set off the server's
    // EXISTS probe). `previousSize` is kept only as a fallback for callers
    // that don't supply it: it comes from the client folder cache and reads 0
    // whenever that cache lacks the old item (folder never opened, stale or
    // paginated listing, file written by the agent/another session) or the
    // old file was empty — which would silently skip the delete and leave a
    // duplicate index behind.
    // Already indexing? Then this would open a SECOND run of the same file — a
    // second collapsed row in the chat, the document read twice, and the delete
    // below wiping what the live run has saved. Asked of the queue, so it also
    // sees a run started from the chatbox or before a reload. Before the delete,
    // never after it.
    // CLAIM, not ask: the claim lands before the request goes out, so a second
    // dispatch made while this one is still in flight sees it. Asking could only
    // ever see a dispatch that had already completed.
    if (!(await chatSession.claimIndexRun(t.storagePath))) {
        console.log("[dbfile] already indexing; skipping index request for", t.storagePath);
        return "skipped";
    }
    const isExisting = !!(t.reindexOnly || t.overwrote || (t.previousSize || 0) > 0);
    try {
        // ONE decision, used twice: the src:: record's own access group and the
        // group the indexing prompt tells the agent to write its records at. Two
        // separate resolutions could disagree (the prompt is per file and the
        // project can be set to ask), and a file whose rows sit in a different
        // group than its record is one that never comes back whole.
        //
        // An EXISTING file keeps the group it already had. Re-indexing or
        // overwriting a file is not a decision about who may see it, and asking
        // again (or applying a changed project default) would silently
        // declassify a file the owner had marked private. Read before the delete
        // below, which destroys the record the group is stored on.
        const existingGroup = isExisting
            ? await readFileIndexAccessGroup(serviceId, t.storagePath)
            : null;
        const accessGroup = existingGroup || await resolveUploadAccessGroup(serviceId, t.batchAccessGroup);
        if (isExisting) {
            await deleteFileIndexRecord(serviceId, t.storagePath);
        }
        saveInfo.attachment.accessGroup = accessGroup;

        // Guarantee the reference target exists before indexing is dispatched. See
        // ensureFileIndexRecord: passes reference "src::<path>" and cannot create it
        // reliably themselves. After the delete, never before it.
        await ensureFileIndexRecord(serviceId, t.storagePath, {
            name: t.name, mime: t.mime, size: t.size,
        }, accessGroup);

        const result: any = await notifyAgentSaveAttachment(saveInfo);
        if (result?.id && typeof result.id === 'string') {
            bgTaskQueue.push({
                serviceId,
                // The engine's BgTaskEntry contract keys everything on projectId
                // (its live-check and the done::-marker mint both read it);
                // serviceId stays for this page's own indexingPaths rebuild.
                projectId: serviceId,
                platform,
                id: result.id,
                filename: t.name,
                storagePath: t.storagePath,
                // Kept-existing file → "Reindexing: …"; new/overwritten → "Indexing: …".
                isReindex: !!t.reindexOnly,
                mime: saveInfo.attachment.mime,
                size: saveInfo.attachment.size,
                status: result.status === 'running' ? 'running' : 'pending',
                poll: result.poll ?? undefined,
            });
            agentHistoryRefreshTrigger[serviceId] = (agentHistoryRefreshTrigger[serviceId] || 0) + 1;
            return "dispatched";
        }
        // An ack with no id is not a dispatch. Treated as success it would close
        // the durable row on the strength of a request nothing can be traced to.
        throw new Error("The indexing request was not accepted.");
    } catch (err) {
        // Nothing was queued, so hand the file's indexing slot back — otherwise this
        // client's own claim refuses the retry. See ChatSession.claimIndexRun.
        chatSession.releaseIndexRun(t.storagePath);
        throw err;
    }
}

/**
 * Dispatch, retrying transport failures, and keep the durable row in step.
 *
 * The row is deleted ONLY once the dispatch is accepted. Until then it is the
 * one record that this file is stored but not yet indexed, which is what makes
 * the setup survive a reload, a crash or a closed tab. Attempts accumulate ACROSS
 * visits: a file that cannot be dispatched three times over is reported to the
 * user instead of being retried on every visit forever.
 */
async function finishIndexSetup(
    t: IndexSetupTarget,
    persistId: string | undefined,
    attemptsAlready: number,
    opts?: { fromRepair?: boolean },
): Promise<void> {
    // Cross-tab claim. Two tabs open on the same project both find the same rows
    // on mount; without this they both dispatch, and the document is read twice.
    if (!(await leaseIndexSetup(persistId, { requireRow: !!opts?.fromRepair }))) {
        // Someone else owns this file's setup (or already finished it), so this
        // page must stop holding its badge back: the guard is per JS context, and
        // the tab doing the work holds its own. Left set, the file would read
        // "not indexed" here until a reload however well the other tab did.
        pendingIndexSetupPaths.delete(pendingSetupKey(t.serviceId, t.storagePath));
        return;
    }
    beginIndexSetup(persistId);
    // Held for the WHOLE window in which the file is stored but not dispatched,
    // by both callers, and released only when a dispatch is accepted. `src::` is
    // written before the dispatch and has to be, so for this window every other
    // signal the badge ladder has says "indexed" for a file nothing has read.
    pendingIndexSetupPaths.add(pendingSetupKey(t.serviceId, t.storagePath));
    let spent = attemptsAlready;
    try {
        for (let local = 1; ; local++) {
            try {
                const outcome = await dispatchIndexSetup(t);
                // 'deferred' means the project changed under us and nothing was
                // dispatched. The row stays, its attempt budget untouched (a
                // navigation is not a failed attempt), for its own project's next
                // visit to repair.
                if (outcome === "deferred") {
                    void releaseIndexSetupLease(persistId);
                    return;
                }
                if (persistId) void unpersistPendingUpload(persistId);
                pendingIndexSetupPaths.delete(pendingSetupKey(t.serviceId, t.storagePath));
                return;
            } catch (err) {
                spent++;
                const budgetLeft = spent < INDEX_SETUP_MAX_ATTEMPTS;
                if (budgetLeft && isRetriableUploadError(err)) {
                    await sleep(uploadRetryDelayMs(local));
                    continue;
                }
                console.error("index setup failed for", t.storagePath, err);
                // Durable: the next visit picks this up, and if the budget is
                // spent it is named in the report rather than retried silently.
                // The badge keeps refusing green either way, because the path
                // stays in pendingIndexSetupPaths.
                if (persistId) {
                    void updatePersistedUpload(persistId, {
                        phase: "index",
                        indexAttempts: spent,
                        error: indexSetupErrorOf(err),
                        // Let another tab, or this one after a reload, retry it
                        // without waiting out the lease.
                        setupLeaseAt: 0,
                    });
                }
                return;
            }
        }
    } finally {
        endIndexSetup(persistId);
    }
}

// Called by onItemUploaded for each finished file. Gets the CDN temp URL then
// requests indexing. Fired without being awaited by the upload worker, so the
// next file starts uploading immediately; the persisted row (moved to the
// 'index' phase before this runs) is what keeps the handover honest if the tab
// dies here. The CSR result is pushed to bgTaskQueue so agent.vue can inject
// Thinking... bubbles right away.
async function onUploadedCollect(info: { file: File; relPath: string; storagePath: string; serviceId?: string; previousSize?: number; reindexOnly?: boolean; overwrote?: boolean; persistId?: string }) {
    // "Reindex" keeps the existing file → no new bytes → no storage change.
    // Otherwise onItemUploaded fires once per successful upload (file.ts
    // `continue`s past the callback on a failed upload), so storage changed by
    // the true delta: +file.size for a new file, or file.size - previousSize
    // when this overwrote an existing same-path file (the server replaced the
    // old object). Runs before the AI-agent early-returns below so usage updates
    // even on services without an agent.
    if (!info.reindexOnly) {
        currentService.value?.adjustFileStorageUsage?.(info.file.size - (info.previousSize || 0));
    }

    // The project the BYTES went to, which is not necessarily the one on screen:
    // the upload queue keeps draining across route changes, so a batch started
    // here and finishing while the user reads another project used to index those
    // files under whatever was open. dispatchIndexSetup compares this against the
    // live service to decide whether it can dispatch now, and that comparison was
    // dead code while both sides read the same ref.
    const serviceId = info.serviceId || currentService.value?.id;
    // The in-flight marker is taken by the upload worker (before this is even
    // fired), so any path that leaves without running the setup has to give it
    // back. Otherwise the row is skipped by every future repair as "already
    // being handled" and the file is never indexed at all.
    if (!serviceId) {
        endIndexSetup(info.persistId);
        return;
    }

    // CAPTURED AND PERSISTED, for the same reason `replacesIndex` is. The answer the
    // user gave for this batch lives in memory on the page that asked, so a repair or
    // a resume after a reload cannot recover it: those files would be indexed at the
    // default ('authorized') though the user answered "Only me", silently widening
    // every file an interruption left behind. Written on the row here, where the
    // stamp is still reachable, and read back by repairPendingIndexSetups.
    const stampedAccessGroup = uploadAccessGroupByFile.get(info.file)
        || (info.persistId ? uploadAccessGroupByPersistId.get(info.persistId) : undefined);
    if (info.persistId && stampedAccessGroup) {
        void updatePersistedUpload(info.persistId, { accessGroup: stampedAccessGroup });
    }

    // Names/sizes come off the File here and off the persisted row on repair.
    // They used to be read from fields this info object never had (info.name,
    // info.mime, info.size were all undefined), so every src:: record fell back
    // to a path-derived name with a null mime and null size.
    await finishIndexSetup(
        {
            serviceId,
            storagePath: info.storagePath,
            name: info.file.name,
            mime: info.file.type || undefined,
            size: info.file.size,
            reindexOnly: info.reindexOnly,
            overwrote: info.overwrote,
            previousSize: info.previousSize,
            // THIS file's batch answer, read here because this is the last place
            // that still has the File the batch hook stamped. Undefined for a
            // resumed or repaired file (different File object, or none at all),
            // which then falls back to the remembered batch answer.
            batchAccessGroup: stampedAccessGroup,
        },
        info.persistId,
        0,
    );
}

const reindexConfirm = ref(false);
const reindexing = ref(false);
const reindexDone = ref(0);
const reindexTotal = ref(0);

// All checked items (files + folders) — used to enable/disable the button.
const checkedItemCount = computed(() =>
    Object.values(checked.value).filter((ns: any) => ns?.name).length
);

// Recursively collect all files under a given directory path.
// dir is in the same format as dbCurrentDirectory (no leading "!").
async function collectFilesInDir(dir: string, results: Array<{ name: string; path: string; size: number }>) {
    let nextPage = false;
    while (true) {
        const result = await currentService.value.listHostDirectory(
            { dir, target: "db" },
            nextPage,
            120
        );
        for (const item of (result.list || [])) {
            if (item.name[0] === '#') {
                const subDir = dir ? `${dir}/${item.name.slice(1)}` : item.name.slice(1);
                await collectFilesInDir(subDir, results);
            } else {
                // Reconstruct the path/name shape the rest of the function expects.
                results.push({ name: item.name, path: `!${dir ? `/${dir}` : ""}`, size: item.size || 0 });
            }
        }
        if (result.endOfList) break;
        nextPage = true;
    }
}

async function reindexAllFiles() {
    if (reindexing.value || !chatReady.value) return;

    const raw = (currentService.value?.service?.ai_agent || "").trim();
    if (!raw) return;

    const [platformRaw, modelRaw] = raw.includes("#") ? raw.split("#") : [raw, ""];
    const platform = (platformRaw === "claude" || platformRaw === "openai")
        ? (platformRaw as "claude" | "openai")
        : null;
    if (!platform) return;

    const checkedItems = Object.values(checked.value) as any[];

    // Seed the list with directly-checked files.
    const filesToIndex: Array<{ name: string; path: string; size: number }> = [];
    for (const ns of checkedItems) {
        if (!ns?.name) continue;
        if (ns.name[0] === '#') {
            // It's a folder — derive the dir path and collect all files inside it.
            const dirPath = (ns.path + "/" + ns.name.slice(1)).split("/").slice(1).join("/");
            await collectFilesInDir(dirPath, filesToIndex);
        } else {
            filesToIndex.push({ name: ns.name, path: ns.path, size: ns.size || 0 });
        }
    }

    if (!filesToIndex.length) return;

    reindexing.value = true;
    reindexDone.value = 0;
    reindexTotal.value = filesToIndex.length;

    const serviceId = currentService.value.id;

    try {
        for (const file of filesToIndex) {
            try {
                const storagePath = (file.path + "/" + file.name).split("/").slice(1).join("/");
                const tu = await currentService.value.getTemporaryUrl({
                    request: "get-db",
                    path: storagePath,
                    expires: 600,
                    generate_temporary_cdn_url: true,
                });
                const url = typeof tu === "string" ? tu : (tu as any)?.url;
                if (!url) { reindexDone.value++; continue; }

                const info: AttachmentSaveInfo = {
                    platform,
                    model: modelRaw || undefined,
                    service: serviceId,
                    publicProjectId: currentService.value?.service?.projectId || undefined,
                    owner: currentService.value.owner,
                    // Same queue base as every other indexing pass and as the
                    // chatbox's turns — see AttachmentSaveInfo.userId.
                    userId: user?.user_id || serviceId,
                    serviceName: currentService.value?.service?.name,
                    serviceDescription: currentService.value?.service?.description,
                    attachment: {
                        name: file.name,
                        storagePath,
                        mime: mime.getType(file.name) || undefined,
                        size: file.size,
                        url,
                    },
                };

                // Already indexing? Then this Reindex would open a SECOND run of the
                // same file: a second collapsed row in the chat, the document read
                // twice, and the delete below wiping what the live run has saved so
                // far. Asked of the queue, so it also sees a run started from the
                // chatbox or before a reload.
                if (!(await chatSession.claimIndexRun(storagePath))) {
                    console.log("[dbfile] already indexing; skipping reindex of", storagePath);
                    reindexDone.value++;
                    continue;
                }
                // Delete-then-repost: this is an explicit Reindex of an existing
                // file, so clear the stale "src::<storagePath>" record first (the
                // skapi backend cascades to its reference-linked children) so the
                // re-index REPLACES rather than duplicates. Best-effort.
                // BEFORE the delete: a re-index must not change a file's
                // visibility, and after the delete the old group is gone. Falls
                // back to the project default only for a file that has no record
                // to preserve.
                // The fallback reads the project setting, so the settings record
                // has to have settled: an unsettled cache would rewrite a file
                // that has no src:: record left at 'authorized' whatever the
                // project chose. Never rejects, and the mount primed it.
                await readyProjectSettings(serviceId);
                const reindexAccessGroup =
                    (await readFileIndexAccessGroup(serviceId, storagePath))
                    || projectUploadAccessGroup(serviceId);
                await deleteFileIndexRecord(serviceId, storagePath);
                info.attachment.accessGroup = reindexAccessGroup;
                await ensureFileIndexRecord(serviceId, storagePath, { name: info?.name, mime: info?.mime, size: info?.size }, reindexAccessGroup);

                const result: any = await notifyAgentSaveAttachment(info);
                if (result?.id && typeof result.id === 'string') {
                    bgTaskQueue.push({
                        serviceId,
                        // Same contract note as the upload path above.
                        projectId: serviceId,
                        platform,
                        id: result.id,
                        filename: info.attachment.name,
                        storagePath: info.attachment.storagePath,
                        // Explicit Reindex action on existing files → "Reindexing: …".
                        isReindex: true,
                        mime: info.attachment.mime,
                        size: info.attachment.size,
                        status: result.status === 'running' ? 'running' : 'pending',
                        poll: result.poll ?? undefined,
                    });
                    agentHistoryRefreshTrigger[serviceId] = (agentHistoryRefreshTrigger[serviceId] || 0) + 1;
                }
            } catch (err) {
                console.error("Reindex failed for file", file.name, err);
                chatSession.releaseIndexRun((file.path + "/" + file.name).split("/").slice(1).join("/"));
            }
            reindexDone.value++;
        }
    } finally {
        reindexing.value = false;
        reindexConfirm.value = false;
        // Re-check index badges for the on-screen files after a reindex pass.
        refreshIndexStatus();
    }
}

// BOTH ENTRY POINTS reset first, and both then ask the batch access question
// through dbUploadOptions.onBeforeBatch before anything is queued. The reset
// clears BOTH remembered answers (the "apply to all" one and the batch one), so
// the question this batch is about to ask cannot be pre-empted by the last
// batch's answer, and nothing that finished uploading earlier can pick up this
// one's. See useAccessGroupPrompt.resetAccessGroupBatch.
let dbUploadFiles = (
    files: FileList | File[],
    callback?: (hasOverwritten: boolean) => void
) => {
    resetOverwriteBatch();
    resetAccessGroupBatch();
    // COPIED, not passed through. This is the file input's own live FileList, and
    // the queue is now built from it AFTER the batch question has been answered
    // (uploadFiles awaits the hook first). A list that changed under us while the
    // modal was open would upload a different set of files than the one the user
    // was asked about, or none at all.
    uploadFiles(
        Array.from(files) as File[],
        callback,
        undefined,
        dbUploadOptions.value
    );
};

let dbOnDrop = (e: any, callback?: (hasOverwritten: boolean) => void) => {
    resetOverwriteBatch();
    resetAccessGroupBatch();
    // RETURNED, not fired and forgotten: onTableDrop awaits this to know when the
    // directory walk is over and the upload rows exist to be shown instead. It
    // now also covers the batch question, which onDrop asks itself once the walk
    // has resolved what a dropped folder actually contains: the "Preparing
    // files..." scrim therefore stays up while that question is on screen, which
    // is also what stops a second drop from starting a second walk behind it.
    return onDrop(e, callback, dbUploadOptions.value);
};

// The gap between the drop and the first progress row. See .bq-drop-preparing.
const preparingDrop = ref(false);

const onTableDrop = async (e: DragEvent) => {
    dragHere.value = false;
    if (!chatReady.value || preparingDrop.value) return;
    // Raised before the first await so the scrim covers the whole walk.
    preparingDrop.value = true;
    try {
        await dbOnDrop(e, onDbUploadDone);
    } finally {
        // onDrop resolves once uploadFiles has queued the files, which is the
        // moment the progress rows have something to say. The scrim comes off
        // there, so there is never a frame with neither it nor the progress.
        preparingDrop.value = false;
    }
};

// Batch-done callback. Refresh the listing, and when any file was overwritten,
// pull authoritative storage usage — onUploadedCollect's per-file delta uses
// the local pager's old size, which can be missing for a file that exists on
// the server but wasn't paged into the listing; refresh() reconciles that.
const onDbUploadDone = (hasOverwritten: boolean) => {
    // Newly uploaded / overwritten files may have (re)indexed — drop cached
    // index statuses so the refreshed listing re-resolves them.
    clearIndexStatus();
    getFileList();
    if (hasOverwritten) void currentService.value?.refresh?.();
};

// ─── resuming an upload that never finished ──────────────────────────────────
// file.ts mirrors every queued db upload into IndexedDB and deletes each row as
// its file settles, so anything still there on mount is work a reload, a crash
// or a closed tab interrupted. It is offered back rather than resumed silently:
// re-uploading thousands of files is not something to start behind the user's
// back, and some of the handles may no longer be readable.
const resumeModal = reactive<{
    open: boolean; count: number; unreadable: number; resumable: boolean; busy: boolean;
}>({ open: false, count: 0, unreadable: 0, resumable: false, busy: false });

let resumableRows: PersistedUpload[] = [];

/**
 * Files stored on the server whose indexing was never dispatched.
 *
 * Read by the badge ladder: `src::` exists for these (it is written before the
 * dispatch, and has to be, because every indexing pass references it), so the
 * ladder's own evidence says "indexed" for a file that was never read. Without
 * this the repair would fix the data while the badge went on asserting the file
 * had been fine all along.
 */
const pendingIndexSetupPaths = reactive(new Set<string>());

/** Keyed by PROJECT too. Storage paths are project-relative, so "reports/q1.xlsx"
 *  names a different file in every project, and a plain path set would hold one
 *  project's badge back on the strength of another's pending row. */
const pendingSetupKey = (serviceId: string | undefined, storagePath: string) =>
    (serviceId || "") + "|" + storagePath;

/** Work that could not be finished and is now the user's to decide about. */
const unfinishedReport = reactive<{
    open: boolean; busy: boolean; failedUploads: PersistedUpload[]; failedIndex: PersistedUpload[];
    /** Files the browser could not remember at all, so they are NOT in the rows
     *  above and cannot be resumed. Reported as a count and names, because the
     *  alternative is a resume prompt that quietly understates what was lost. */
    untracked: UntrackedUploads;
}>({ open: false, busy: false, failedUploads: [], failedIndex: [], untracked: { count: 0, names: [] } });

/** Grouped by cause, exactly like the live batch report, and capped the same way
 *  so a 10k batch cannot render 10k list items. */
const unfinishedReportGroups = computed(() =>
    groupAttachmentFailures(
        unfinishedReport.failedUploads.concat(unfinishedReport.failedIndex).map((r) => ({
            name: r.currentDir + r.relPath,
            status: "error",
            errorCode: r.error?.code || "",
            errorDetail: r.error?.message || "",
        })),
    ).map((g) => ({
        code: g.code,
        message: g.message,
        files: g.files.slice(0, MAX_ERROR_FILES_SHOWN),
        moreCount: Math.max(0, g.files.length - MAX_ERROR_FILES_SHOWN),
    })),
);

/**
 * Finish the index setup for files whose bytes are already stored.
 *
 * Runs on mount, silently and without asking: there is nothing for the user to
 * decide (no bytes to re-send, no conflict to resolve), and the alternative is a
 * file that sits in storage looking indexed forever. Bounded, because a 10k
 * batch interrupted halfway leaves 10k of these.
 */
async function repairPendingIndexSetups(rows: PersistedUpload[]) {
    if (!rows.length) return;
    for (const r of rows) pendingIndexSetupPaths.add(pendingSetupKey(r.serviceId, r.currentDir + r.relPath));
    // Repainted immediately: until these are dispatched the badge must not claim
    // they are indexed, and the ladder caches its verdicts.
    refreshIndexStatus();
    await runBounded(rows, INDEX_SETUP_CONCURRENCY, async (r) => {
        const storagePath = r.currentDir + r.relPath;
        // No release here: the guard belongs to finishIndexSetup, which drops it
        // only when a dispatch is ACCEPTED. Releasing it per attempt handed a
        // file whose dispatch had just failed straight back to the ladder, which
        // then ripened it into a durable green that no later pass could demote.
        await finishIndexSetup(
            {
                serviceId: r.serviceId,
                storagePath,
                name: r.name,
                mime: r.type || undefined,
                size: r.size,
                // A repair never re-uploads, so it cannot overwrite anything NOW.
                // Whether the original upload replaced an existing file is not
                // derivable after a reload (the folder cache it came from is
                // gone), so it is carried on the row. Without it the repair skips
                // delete-then-repost and stacks a second set of extracted records
                // on top of the old file's.
                reindexOnly: false,
                overwrote: !!r.replacesIndex,
                // Carried on the row for the same reason replacesIndex is: the answer
                // the user gave for this batch lived in memory on the page that asked
                // and did not survive the reload. Without it, resolveUploadAccessGroup
                // has nothing of this file's own to spend and falls to the project
                // default, so a batch answered "Only me" comes back readable by every
                // signed-in user. Absent on rows written before the field existed, and
                // on projects that name a group (nothing was asked, nothing to replay).
                batchAccessGroup: (r as any).accessGroup as UploadAccessGroup | undefined,
                previousSize: 0,
            },
            r.id,
            r.indexAttempts || 0,
            { fromRepair: true },
        );
    });
    refreshIndexStatus();
}

async function checkForResumableUploads() {
    const svc = currentService.value?.id;
    if (!svc) return;
    let all: PersistedUpload[] = [];
    try {
        all = await listPendingUploads(svc);
    } catch (err) {
        return; // resume is a convenience; never let it break the page
    }
    // NOT before the untracked note is read. That note is the record of files the
    // browser could not remember AT ALL, so "no rows" is precisely the state it
    // describes, and returning here made the one report that could mention them
    // unreachable exactly when it mattered. The mirror budget makes that state
    // ordinary rather than exotic: a file over the per-file limit gets a note and
    // no row by design.
    if (!all.length) {
        const untrackedOnly = readUntrackedUploads(currentService.value?.id || "");
        if (untrackedOnly.count) {
            unfinishedReport.failedUploads = [];
            unfinishedReport.failedIndex = [];
            unfinishedReport.untracked = untrackedOnly;
            unfinishedReport.open = true;
        }
        return;
    }

    // Three different kinds of unfinished work share this store, and only one of
    // them is "an upload that never happened". Partitioning FIRST is what keeps
    // the offer's count honest and keeps a blob-less row out of the upload queue.
    const setupPending: PersistedUpload[] = [];
    const setupExhausted: PersistedUpload[] = [];
    const failedUploads: PersistedUpload[] = [];
    let rows: PersistedUpload[] = [];
    for (const r of all) {
        const phase = phaseOf(r);
        if (phase === "index") {
            // Still being dispatched by a setup this page (or a previous route)
            // started. Re-driving it would index the document twice.
            if (isIndexSetupInFlight(r.id)) continue;
            if ((r.indexAttempts || 0) >= INDEX_SETUP_MAX_ATTEMPTS) setupExhausted.push(r);
            else setupPending.push(r);
        } else if (phase === "failed") {
            failedUploads.push(r);
        } else {
            rows.push(r);
        }
    }

    // Files the browser never managed to record. They are in no row, so they can
    // only be named, not resumed. Read BEFORE the counts below are shown, so the
    // prompt never states a total it knows to be short.
    const untracked = readUntrackedUploads(svc);

    if (failedUploads.length || setupExhausted.length || untracked.count) {
        unfinishedReport.failedUploads = failedUploads;
        unfinishedReport.failedIndex = setupExhausted;
        unfinishedReport.untracked = untracked;
        unfinishedReport.open = true;
        // Their paths are stored but unindexed, and stay that way until the user
        // acts, so the badge must keep saying so.
        for (const r of setupExhausted) pendingIndexSetupPaths.add(pendingSetupKey(r.serviceId, r.currentDir + r.relPath));
    }
    // Deliberately not awaited: the repair is background work and the upload
    // offer below must not wait on a few thousand dispatches to be shown.
    void repairPendingIndexSetups(setupPending);

    if (!rows.length) return;

    // Subtract what this page is STILL UPLOADING. The upload queue is a module
    // singleton that keeps running across route changes, and a persisted row
    // lives until its item settles — so leaving this page mid-upload and coming
    // back offered to "resume" the very files that were still uploading, and
    // accepting queued them a second time. They then uploaded alongside the
    // originals (db uploads run several workers), each firing onItemUploaded, and
    // one file became TWO index requests: two collapsed rows in the chat, the
    // document read twice, every record saved twice.
    const busy = inFlightUploadIds();
    rows = rows.filter((r) => !busy.has(r.id));
    if (!rows.length) return;

    // A persisted File points at bytes on disk. If the file moved or changed the
    // handle is stale and reading throws, so probe before offering — a resume
    // that dies file-by-file mid-batch is worse than an honest count up front.
    const readable: PersistedUpload[] = [];
    let unreadable = 0;
    for (const r of rows) {
        if (await isFileStillReadable(r.file)) readable.push(r);
        else { unreadable++; void unpersistPendingUpload(r.id); }
    }

    resumableRows = readable;
    resumeModal.count = rows.length;
    resumeModal.unreadable = unreadable;
    resumeModal.resumable = readable.length > 0;
    resumeModal.open = true;
}

function doResumeUploads() {
    if (resumeModal.busy || !resumableRows.length) return;
    resumeModal.busy = true;
    resetOverwriteBatch();
    resetAccessGroupBatch();
    // Replay each row's own answer. resetAccessGroupBatch() above deliberately clears
    // the LIVE batch answer (a resume is not a new batch and must not inherit one), so
    // without this the resumed files would fall to the project default.
    for (const r of resumableRows) {
        const g = (r as any).accessGroup as UploadAccessGroup | undefined;
        if (g) uploadAccessGroupByPersistId.set(r.id, g);
    }
    enqueueResumedUploads(resumableRows, {
        foldersRef: dbServiceFolders,
        storeKey: dbstore.value,
        callback: onDbUploadDone,
        onItemUploaded: onUploadedCollect,
        onBeforeItem: (info: { file: File }) => promptOverwrite(info.file.name),
    });
    resumableRows = [];
    resumeModal.open = false;
    resumeModal.busy = false;
}

async function discardResume() {
    if (resumeModal.busy) return;
    resumeModal.busy = true;
    // ONLY the rows this offer actually showed. Clearing the whole service was
    // reachable while a batch was uploading (leftovers open the modal, the live
    // batch's own rows are excluded from it), and it deleted the durability of an
    // upload that was still running: the batch kept going, but a crash after that
    // point had nothing left to offer back and nothing to report.
    await unpersistPendingUploads(resumableRows.map((r) => r.id));
    resumableRows = [];
    resumeModal.open = false;
    resumeModal.busy = false;
}

/** Retry everything in the report: failed uploads go back through the upload
 *  queue (their bytes are still persisted), un-dispatched files just need their
 *  setup run again with a fresh attempt budget. */
async function retryUnfinished() {
    if (unfinishedReport.busy) return;
    unfinishedReport.busy = true;
    const uploads = unfinishedReport.failedUploads.slice();
    const setups = unfinishedReport.failedIndex.slice();
    unfinishedReport.failedUploads = [];
    unfinishedReport.failedIndex = [];
    // Nothing to retry for these: no row, no blob, nothing to point at. The user
    // has now been told, which is all this note could ever achieve.
    const svcNow = currentService.value?.id;
    if (svcNow) clearUntrackedUploads(svcNow);
    unfinishedReport.untracked = { count: 0, names: [] };
    unfinishedReport.open = false;
    unfinishedReport.busy = false;

    if (uploads.length) {
        resetOverwriteBatch();
        resetAccessGroupBatch();
        // Back to the 'upload' phase: these rows are about to be attempted as
        // uploads again, and a row left saying 'failed' would be reported a
        // second time while its retry was still in flight.
        for (const r of uploads) {
            await updatePersistedUpload(r.id, { phase: "upload", error: undefined });
            // Same replay as doResumeUploads: the retried File is rehydrated, so the
            // WeakMap cannot recognise it and the row is the only place its answer
            // survives.
            const g = (r as any).accessGroup as UploadAccessGroup | undefined;
            if (g) uploadAccessGroupByPersistId.set(r.id, g);
        }
        enqueueResumedUploads(uploads, {
            foldersRef: dbServiceFolders,
            storeKey: dbstore.value,
            callback: onDbUploadDone,
            onItemUploaded: onUploadedCollect,
            onBeforeItem: (info: { file: File }) => promptOverwrite(info.file.name),
        });
    }
    if (setups.length) {
        for (const r of setups) {
            await updatePersistedUpload(r.id, { indexAttempts: 0, error: undefined });
            r.indexAttempts = 0;
        }
        void repairPendingIndexSetups(setups);
    }
}

/** Give up on them. The files stay exactly as they are (uploaded but not
 *  indexed, or not uploaded at all); only the record of them is dropped, and the
 *  badge stops being held back from its own verdict. */
async function discardUnfinished() {
    if (unfinishedReport.busy) return;
    unfinishedReport.busy = true;
    const rows = unfinishedReport.failedUploads.concat(unfinishedReport.failedIndex);
    const setups = unfinishedReport.failedIndex.slice();
    await unpersistPendingUploads(rows.map((r) => r.id));
    const svcNow = currentService.value?.id;
    if (svcNow) clearUntrackedUploads(svcNow);
    unfinishedReport.failedUploads = [];
    unfinishedReport.failedIndex = [];
    unfinishedReport.untracked = { count: 0, names: [] };
    unfinishedReport.open = false;
    unfinishedReport.busy = false;

    // Dropping the durable row hands the badge back to `src::`, which THIS
    // client wrote before a dispatch that never happened. Left alone it ripens
    // into a permanent green for a file the agent has never read, which is the
    // exact lie this whole change exists to stop. So the orphan record goes too.
    // Bounded: a large batch can leave thousands, and each delete sweeps unique
    // ids. Each path stays held back from green until its delete lands.
    void runBounded(setups, INDEX_SETUP_CONCURRENCY, async (r) => {
        const sp = r.currentDir + r.relPath;
        try {
            // Unless something IS indexing it after all, in which case the record
            // is live and deleting it would wipe what that run has saved.
            if (!liveOnServer(sp, r.name)) await deleteFileIndexRecord(r.serviceId, sp);
        } finally {
            pendingIndexSetupPaths.delete(pendingSetupKey(r.serviceId, sp));
        }
    }).then(() => refreshIndexStatus());
    refreshIndexStatus();
}

/** Dismissed without choosing: keep the rows so the report returns next visit. */
function dismissUnfinished() {
    if (unfinishedReport.busy) return;
    unfinishedReport.open = false;
}

// Dismissed without choosing: keep the rows so the offer returns next visit.
function dismissResume() {
    if (resumeModal.busy) return;
    resumeModal.open = false;
}

// Manual refresh button — force a fresh listing. The refresh button spins and
// the bunny loader covers the table while it loads (via getFileListFetching).
const refreshFileList = () => {
    if (getFileListFetching.value || !chatReady.value) return;
    // Deliberate refresh → re-verify every file, including cached "indexed" ones,
    // against a fresh look at the indexing queue.
    resetIndexCache();
    void refreshLiveIndexProbe(true);
    getFileList(true);
    // Media only appears once an indexing run has finished, so re-ask rather than
    // trusting a cached "this directory has none".
    loadMediaIndex(dbCurrentDirectory.value || "", true);
};

const resultsPerPage = 12;
let listDisplay = ref([]);
let sortBy = ref("name");
let ascending = ref(true);
let currentPage = ref(1);
let endOfList: any = reactive({});
let maxPage = ref(0);
let getFileListFetching = ref(true); // init value should be true
let hasFetchedOnce = ref(false); // true after the first directory fetch completes
// Directory the in-flight getFileList() is fetching for, and a flag saying a
// directory change was swallowed while that fetch was running. Without these a
// dir change that lands mid fetch is silently dropped and never re-scheduled.
let fetchingDir: string | null = null;
let pendingDirRefetch = false;

let isDirEndOfList = (dir: string) => {
    // Read the reactive map. folders is a plain (non reactive) object used for
    // cross mount persistence, so reading it here would freeze the computed.
    return !!endOfList[dir];
};

let isCurrentDirEndOfList = computed(() => {
    return isDirEndOfList(dbCurrentDirectory.value || "!");
});

// checks
let checked: any = ref({});
let headerCheckState = computed(() => {
    if (!listDisplay.value || listDisplay.value.length === 0) return false;
    let allPageChecked = listDisplay.value.every(
        (d: any) => checked.value[d.name]
    );
    if (allPageChecked) return true;
    let someChecked = Object.keys(checked.value).length > 0;
    if (someChecked) return null;
    return false;
});

const toggleHeaderCheck = () => {
    if (headerCheckState.value === true) {
        checked.value = {};
    } else {
        if (listDisplay.value?.length) {
            listDisplay.value.forEach((d: any) => (checked.value[d.name] = d));
        }
    }
};

let deleteSelected = ref(false);

let deleteFiles = async () => {
    modalPromise.value = true;
    let toDel = Object.values(checked.value).filter(
        (v: any) =>
            !!v &&
            typeof v.name === "string" &&
            v.name.length > 0 &&
            typeof v.path === "string"
    ) as any[];

    try {
        let currDir = dbCurrentDirectory.value || "!";
        let pager = folders[currDir]?.pager;

        // Bytes about to be freed. A folder item's `.size` is the recursive
        // aggregate of its contents, so this covers folder deletes too.
        const freedBytes = toDel.reduce(
            (sum, v) => sum + (Number(v.size) || 0),
            0
        );

        await currentService.value.deleteHostFiles({
            target: "db",
            paths: toDel.map(
                (v) =>
                    v.path +
                    "/" +
                    (() => {
                        let n = v.name as string;
                        if (n.startsWith("#")) {
                            return n.slice(1) + "/";
                        }
                        return n;
                    })()
            ),
        });

        // Server delete succeeded — optimistically drop the displayed usage.
        currentService.value.adjustFileStorageUsage(-freedBytes);

        // Deleting a db file removes its src:: index record server-side, so drop
        // the matching entries from the persisted index cache.
        pruneIndexCacheForDeleted(toDel);

        for (let v of toDel) {
            if (pager) {
                await pager.deleteItem(v.name);
            }
        }

        getFileList();

        deleteSelected.value = false;
        checked.value = {};
    } catch (err: any) {
        if (err instanceof SkapiError) {
            alert(err.message);
        } else {
            throw err;
        }
    } finally {
        modalPromise.value = false;
    }
};

let restoreCachedFolders = () => {
    let key = dbstore.value;

    if (dbServiceFolders?.[key] && Object.keys(dbServiceFolders[key]).length) {
        folders = dbServiceFolders[key];
    } else {
        dbServiceFolders[key] = folders;
    }
};

restoreCachedFolders();

// True once the directory/file listing chain has been kicked off; the
// dbDirInfo watcher below fetches only after this so a setup-required page
// (no platform picked) still fetches nothing.
let listInitStarted = false;
const initDbFileList = () => {
    listInitStarted = true;
    getFileListFetching.value = true;
    currentService.value.getDirInfo({ target: "db" });
};

// Resolve API-key state up front so the overlays show the right step.
if (hasAiPlatform.value) {
    void refreshApiKey();
    // Speculative: a configured platform almost always has a key, and the
    // listing does not need it — run getDirInfo/getFileList in PARALLEL with
    // the key lookup instead of behind it. If the key turns out missing the
    // fetched listing stays hidden behind the setup overlay (and is warm for
    // when a key is added). Badge resolution that needs chatReady re-runs in
    // the chatReady watcher below.
    initDbFileList();
} else {
    hasAiApiKey.value = false;
    // Don't fetch anything until the user picks an AI platform.
    getFileListFetching.value = false;
}
removeFullScreenLoader();

// Reconcile the "Usage" figure (formattedSpecs.serviceStatus.storage.file) with
// the backend after a chatbox (agent.vue) upload — WITHOUT letting a lagging
// backend total regress it below the bytes we already know were uploaded.
// Server-side storage aggregation can lag a just-completed upload, so a blind
// refresh() could momentarily snap the figure back to the pre-upload total. The
// frontend-known bytes (applied optimistically via adjustFileStorageUsage in the
// chatbox path) are the lag-free floor; refresh() picks up authoritative/external
// changes once the backend catches up. So: snapshot the current (optimistic)
// figure, refresh, and if the backend came back LOWER (upload not yet aggregated)
// re-add the shortfall so the number never dips right after the user's upload.
// The next reconcile self-corrects once the backend total >= the optimistic one.
const reconcileStorageUsage = () => {
    const optimistic = currentService.value?.service?.storage_info?.file ?? 0;
    const p = currentService.value?.refresh?.();
    if (!p || typeof p.then !== "function") return;
    p.then(() => {
        const authoritative = currentService.value?.service?.storage_info?.file ?? 0;
        if (authoritative < optimistic) {
            currentService.value?.adjustFileStorageUsage?.(optimistic - authoritative);
        }
    }).catch(() => {});
};

watch(
    () => currentService.value.dbDirInfo.path,
    (path) => {
        // Gated on the listing chain having been started (not on chatReady):
        // the speculative mount init above fetches while the key lookup is
        // still in flight. A setup-required page never sets listInitStarted.
        if (!listInitStarted) return;
        if (path) {
            // If a chatbox upload bumped the refresh trigger while this page was
            // unmounted, the cached pager is stale — force a fresh listing on
            // arrival instead of restoring the cache. Mark the bump consumed.
            const sid = currentService.value?.id;
            let stale = false;
            if (sid) {
                const cur = dbFileRefreshTrigger[sid];
                stale = typeof cur === "number" && dbFileRefreshLastSeen[sid] !== cur;
                if (typeof cur === "number") dbFileRefreshLastSeen[sid] = cur;
            }
            // A chatbox (agent.vue) upload that landed while this page was
            // unmounted also changed db-file storage usage, but only bumped the
            // LISTING trigger — reconcile the "Usage" figure on arrival
            // (reconcileStorageUsage above is lag-safe against the server).
            if (stale) {
                // The bump means files changed while this page was away — the
                // module-level negative memo may be wrong now, drop it (the
                // transient layer is fresh on mount anyway). Deferred to
                // nextTick like the media wipe below: this watcher is
                // immediate, so on a fresh mount it runs before the badge
                // bindings (clearIndexStatus/unindexedChecked) are initialized.
                void nextTick(() => clearIndexStatus());
                reconcileStorageUsage();
                // Anything uploaded while away may have finished indexing by
                // now, minting new extracted media the cached listings can't
                // know about — drop them and re-ask for the directory on
                // screen. Deferred to nextTick: this watcher is immediate, so
                // on a fresh mount it runs before the media bindings below are
                // initialized.
                void nextTick(() => {
                    for (const d in mediaIndex) delete mediaIndex[d];
                    loadMediaIndex(dbCurrentDirectory.value || "", true);
                });
            }
            getFileList(stale ? true : "conditional").then(() => {
                getFileListFetching.value = false;
                hasFetchedOnce.value = true;
            });
        }
    },
    {
        immediate: true,
    }
);

// Live background refresh: a chatbox (agent.vue) upload batch finishing bumps
// dbFileRefreshTrigger. If this page is currently open, refresh the listing in
// place (the refresh button spins via getFileListFetching). A bump that lands
// while this page is unmounted is instead caught by the dbDirInfo watcher above
// on next mount.
watch(
    () => dbFileRefreshTrigger[currentService.value?.id],
    (cur) => {
        const sid = currentService.value?.id;
        if (!sid || typeof cur !== "number") return;
        if (dbFileRefreshLastSeen[sid] === cur) return;
        if (!chatReady.value) return;
        dbFileRefreshLastSeen[sid] = cur;
        clearIndexStatus();
        // The chatbox batch also changed db-file storage usage — reconcile the
        // "Usage" figure (this trigger otherwise refreshes the listing only).
        reconcileStorageUsage();
        getFileList(true);
    }
);

// When platform + API key are first both present: either kick off the listing
// we skipped (no platform at mount), or — when the speculative mount init
// already fetched it — resolve the index badges that checkIndexStatus /
// refreshLiveIndexProbe skipped while chatReady was still false.
watch(chatReady, (now, prev) => {
    if (now && !prev) {
        if (!listInitStarted) {
            initDbFileList();
        } else {
            refreshIndexStatus();
        }
    }
});

// React to external `ai_agent` changes (e.g. user changed platform on the
// agent page): re-resolve the API-key state for the new platform.
watch(
    () => currentService.value?.service?.ai_agent,
    () => {
        if (hasAiPlatform.value) {
            void refreshApiKey();
        } else {
            hasAiApiKey.value = false;
            gateLoading.value = false;
        }
    }
);

// When a db upload batch settles, surface any failures in a modal that lists
// the failed files grouped by cause. Also refresh the service so the usage
// display reflects current storage consumption (e.g. after an EXCEED_LIMIT
// error).
watch(() => dbUploadResult.token, () => {
    const failed = dbUploadResult.failed;
    if (!failed.length) return;
    failedUploads.value = [...failed];
    uploadErrorModal.value = true;
    currentService.value?.refresh?.().catch(() => {});
});

let setNewDir = (ns: any) => {
    if (!ns?.path || !ns?.name) {
        return dbCurrentDirectory;
    }

    let path = ns.path;
    path = path.split("/");
    if (path.length > 1) {
        dbCurrentDirectory.value =
            path.slice(1).join("/") + "/" + ns.name.slice(1);
    } else {
        dbCurrentDirectory.value = ns.name.slice(1);
    }

    return dbCurrentDirectory;
};

watch(dbCurrentDirectory, () => {
    checked.value = {};
    getFileList();
    loadMediaIndex(dbCurrentDirectory.value || "");
});

async function getFileList(refresh: string | boolean = false) {
    if (!refresh && getFileListFetching.value) {
        // Don't lose a directory change: the in-flight fetch belongs to another
        // directory, so queue a re-run for the one we're actually on now.
        if (fetchingDir !== null && (dbCurrentDirectory.value || "!") !== fetchingDir) {
            pendingDirRefetch = true;
        }
        return;
    }

    getFileListFetching.value = true;

    let currDir = dbCurrentDirectory.value || "!";
    fetchingDir = currDir;
    let hasPage = folders?.[currDir]?.pager;

    let pager = null;

    if (hasPage) {
        pager = folders[currDir].pager;
        if (typeof folders[currDir].endOfList !== "boolean") {
            folders[currDir].endOfList = !!endOfList[currDir];
        }
        endOfList[currDir] = folders[currDir].endOfList;
        maxPage.value = Math.ceil(pager.map.length / pager.resultsPerPage);
    }

    if (!hasPage || (refresh && refresh !== "conditional")) {
        folders[currDir] = {
            pager: await Pager.init({
                id: "name",
                sortBy: sortBy.value,
                order: ascending.value ? "asc" : "desc",
                resultsPerPage,
            }),
            endOfList: false,
        };
        maxPage.value = 0;
        currentPage.value = 1;
        endOfList[currDir] = false;
    }

    pager = folders[currDir].pager;

    if (refresh && refresh !== "conditional") {
        checked.value = {};
    }

    // We must hit the server on a hard refresh, or whenever the pager doesn't
    // yet hold enough items to BOTH fill the current page AND peek one item
    // into the next page. That one-page lookahead is what lets the Next button
    // know whether another page really exists: the server can report
    // endOfList=false on a batch that happens to be the last one (a full batch
    // whose count hits the query limit still carries a startKey), only
    // reporting endOfList=true on the following, empty fetch. Without the peek
    // the button would stay enabled on the final page and a click would land on
    // a blank page.
    let mustFetch =
        (refresh && refresh !== "conditional") ||
        (!isDirEndOfList(currDir) &&
            pager.map.length <= currentPage.value * resultsPerPage);

    if (mustFetch) {
        try {
            // First fetch mirrors the previous behaviour: a hard refresh or a
            // cold pager fetches fresh (startKey reset); everything else
            // continues from the stored startKey.
            let fetchMore = !(refresh || maxPage.value == 0);
            let guard = 0;
            while (true) {
                let l = await currentService.value.listHostDirectory(
                    // Always request the SNAPSHOT directory. Reading the live
                    // ref here would fetch another directory's rows into this
                    // directory's pager if the user navigated mid loop.
                    { dir: currDir === "!" ? "" : currDir, target: "db" },
                    fetchMore,
                    resultsPerPage * 10 // one fetch covers 10 UI pages
                );
                // The user navigated away while we were awaiting. Everything
                // below writes shared page state, so bail and let the queued
                // re-run fetch the directory we're actually on.
                if ((dbCurrentDirectory.value || "!") !== currDir) {
                    pendingDirRefetch = true;
                    return;
                }
                // listHostDirectory hides system-managed folders, so `l.list`
                // can be empty while the server actually returned rows. Drive
                // the end-of-directory decision off the RAW (pre-filter) count
                // so a fully-filtered page keeps paging instead of being
                // mistaken for the end of the listing.
                let fetchedRaw =
                    typeof l.rawCount === "number" ? l.rawCount : l.list.length;
                if (l.list.length > 0) {
                    await pager.insertItems(l.list);
                }
                if (fetchedRaw > 0) {
                    endOfList[currDir] = l.endOfList;
                    folders[currDir].endOfList = l.endOfList;
                } else {
                    endOfList[currDir] = true;
                    folders[currDir].endOfList = true;
                }
                // Continue from the server startKey on every subsequent pass.
                fetchMore = true;

                // Stop once the server says we're done, once we have the
                // one-page lookahead, or (defensively) if the server returned
                // nothing at all or we've looped too many times.
                if (
                    isDirEndOfList(currDir) ||
                    pager.map.length > currentPage.value * resultsPerPage ||
                    fetchedRaw === 0 ||
                    ++guard > 20
                ) {
                    break;
                }
            }

            if ((dbCurrentDirectory.value || "!") !== currDir) {
                pendingDirRefetch = true;
                return;
            }

            // If we paged past the real end (e.g. a previous "next" landed us
            // one page beyond the data, or a delete shrank the list), fall back
            // to the last page that actually has rows instead of showing a
            // blank page.
            maxPage.value = Math.ceil(pager.map.length / pager.resultsPerPage);
            if (currentPage.value > maxPage.value) {
                currentPage.value = Math.max(1, maxPage.value);
            }

            let fl = pager.getPage(currentPage.value);
            listDisplay.value = fl.list;
            maxPage.value = fl.maxPage;
        } finally {
            getFileListFetching.value = false;
            fetchingDir = null;
            if (pendingDirRefetch) {
                pendingDirRefetch = false;
                getFileList();
            }
        }
    } else {
        // Serving from the pager: clamp a stale currentPage (e.g. after a
        // delete removed the last page, or emptied the directory entirely) so
        // we never render an empty page. Floors to 1 when maxPage is 0.
        if (currentPage.value > 1 && currentPage.value > maxPage.value) {
            currentPage.value = Math.max(1, maxPage.value);
        }
        let fl = pager.getPage(currentPage.value);
        listDisplay.value = fl.list;
        maxPage.value = fl.maxPage;
        getFileListFetching.value = false;
        fetchingDir = null;
        if (pendingDirRefetch) {
            pendingDirRefetch = false;
            getFileList();
        }
    }
}

let resetIndex = async () => {
    let currDir = dbCurrentDirectory.value || "!";
    await folders[currDir].pager.resetIndex({
        sortBy: sortBy.value,
        order: ascending.value ? "asc" : "desc",
    });
    if (currentPage.value !== 1) {
        currentPage.value = 1;
    } else {
        getFileList();
    }
};

// Whether a header click can do anything right now. The header reads this so a
// column that will refuse the click does not advertise itself as sortable.
let canSort = computed(
    () => !getFileListFetching.value && !!listDisplay.value?.length
);

// Only one column is ever the applied ordering, so the tooltip says which state
// the click leads to rather than leaving the user to guess from the arrow.
let sortTitle = (c: any) => {
    if (!canSort.value) return "";
    if (sortBy.value !== c.key) return `Sort by ${c.name}`;
    return ascending.value
        ? `Sorted by ${c.name} (ascending). Click for descending.`
        : `Sorted by ${c.name} (descending). Click for ascending.`;
};

let toggleSort = (search: any) => {
    if (!canSort.value) {
        return;
    }

    if (sortBy.value === search) {
        ascending.value = !ascending.value;
    } else {
        sortBy.value = search;
    }
};

// call getPage when currentPage changes
watch(currentPage, (n, o) => {
    if (
        n !== o &&
        n > 0 &&
        // Page 1 is always a legal destination — even for an empty directory
        // (maxPage === 0). Without the Math.max floor, emptying the current
        // directory while on page ≥2 (e.g. deleting a cross-page selection)
        // would make every page value illegal, so the revert below would set
        // another illegal value and the watcher would ping-pong indefinitely.
        (n <= Math.max(1, maxPage.value) ||
            (n > maxPage.value &&
                !isDirEndOfList(dbCurrentDirectory.value || "!")))
    ) {
        getFileList();
    } else {
        currentPage.value = o;
    }
});

// initialize the pager when sort changes
watch([sortBy, ascending], () => {
    if (!getFileListFetching.value) {
        let currDir = dbCurrentDirectory.value || "!";
        if (isDirEndOfList(currDir)) {
            resetIndex();
        } else {
            getFileList(true);
        }
    }
});

// mobile infinite scroll
const isMobile = ref(false);
const mobileListRef = ref<HTMLElement | null>(null);

const checkMobileResize = () => {
    isMobile.value = window.innerWidth <= 768;
};

const mobileAllItems = computed(() => {
    let _ = listDisplay.value;
    let mp = maxPage.value;
    let currDir = dbCurrentDirectory.value || "!";
    if (!isMobile.value || !folders?.[currDir]?.pager || mp <= 0) return [];
    let pager = folders[currDir].pager;
    let allItems: any[] = [];
    for (let i = 1; i <= mp; i++) {
        let page = pager.getPage(i);
        allItems.push(...page.list);
    }
    return allItems;
});

// ─── AI-index status ──────────────────────────────────────────────────────
// Each db-storage file the AI agent indexes gets a record whose unique_id is
// `src::<storagePath>` (storagePath = path with the leading "!" stripped — the
// same shape openFile/reindex/upload use). For the files currently shown we
// batch a lightweight getUniqueId existence lookup per file: a hit means the
// file is indexed for AI search, a miss means it isn't.
//
// TWO-LAYER cache so returning to this page doesn't refetch everything:
//   • indexedSet (module-level `dbIndexedPaths[serviceId]`, survives remounts):
//     storage paths CONFIRMED indexed. The durable state — once indexed a file
//     stays indexed until it's deleted — so it's cached across navigations.
//   • indexStatus (component-local, resets each mount): transient checking/
//     unindexed. "unindexed" is intentionally NOT persisted, so a file that
//     finished indexing while the page was away is re-verified on return and
//     flips to "indexed" (no cross-page signal needed).
//
// A file CURRENTLY (re)indexing has a live bgTaskQueue entry (pushed by this
// page / agent.vue, drained by main.vue's fallback poller). While that entry
// exists we show "indexing" (overrides the cache); when it's removed we re-check
// so the badge flips indexing → indexed.
type IndexState = "checking" | "indexing" | "indexed" | "unindexed";
const svcId = currentService.value.id;
if (!dbIndexedPaths[svcId]) dbIndexedPaths[svcId] = new Set<string>();
const indexedSet = dbIndexedPaths[svcId];
const indexStatus = reactive<Record<string, "checking" | "unindexed">>({});
// Recent authoritative "unindexed" answers (module-level, see file.ts): lets a
// remount re-paint the badge WITHOUT re-firing the src::/done:: lookups when
// the answer is fresh. Not the durable indexedSet — entries expire and are
// invalidated by everything that can flip the answer.
if (!dbUnindexedChecked[svcId]) dbUnindexedChecked[svcId] = new Map<string, number>();
const unindexedChecked = dbUnindexedChecked[svcId];
// Rows painted green from a CHAT-page verdict while the background pair
// verifies. Component-local on purpose: a remount re-derives from
// chatIndexVerdicts, and a verified answer replaces the seed either way.
const seededGreen = reactive(new Set<string>());
// Rows whose run:: record says a run is WORKING right now (and recently — see
// RUN_RECORD_WORKING_STALE_MS). This is the one signal that can show a
// collaborator's or a widget end-user's run as yellow: the live-queue probe
// only sees THIS user's "<userId>-bg" queue. Kept out of liveIndexProbe.keys
// on purpose (every probe response overwrites that set); consulted by
// fileIndexState at the same precedence tier. Re-verified on a short timer
// while non-empty, since no probe/finish watcher covers a foreign run.
const runWorking = reactive(new Set<string>());
// The cadence deliberately EQUALS the sweep TTL: each tick's checkIndexStatus
// then fetches a naturally-expired (fresh) sweep without ever invalidating the
// cache out from under the chat page, and the rows HOLD their yellow until the
// fresh answer reconciles them — the consumption block removes a path from
// runWorking on every outcome (done, error/cancelled, record gone), so there
// is no wipe-then-restore blink and no forced re-fetch storm.
const RUN_WORKING_RECHECK_MS = 30_000;
let runWorkingTimer: ReturnType<typeof setTimeout> | null = null;
const armRunWorkingRecheck = () => {
    if (runWorkingTimer !== null || runWorking.size === 0) return;
    runWorkingTimer = setTimeout(() => {
        runWorkingTimer = null;
        if (liveProbeDisposed) return;
        if (document.hidden || runWorking.size === 0) { armRunWorkingRecheck(); return; }
        checkIndexStatus((isMobile.value ? mobileAllItems.value : listDisplay.value) as any[]);
        armRunWorkingRecheck();
    }, RUN_WORKING_RECHECK_MS);
};
const unindexedFresh = (sp: string): boolean => {
    const at = unindexedChecked.get(sp);
    return typeof at === "number" && Date.now() - at < DB_UNINDEXED_TTL_MS;
};
// Icons are limited to the Material Symbols allowlist in index.html's font URL
// (`icon_names=…`); `database_search` and `sync` are both already included.
const INDEX_BADGE: Record<IndexState, { icon: string; title: string }> = {
    checking: { icon: "sync", title: "Checking AI index…" },
    indexing: { icon: "sync", title: "Indexing for AI…" },
    indexed: { icon: "database_search", title: "Indexed for AI search" },
    unindexed: { icon: "database_search", title: "Not indexed for AI" },
};

// storagePath for a file row (mirrors openFile/reindex: strip the leading "!").
const fileStoragePath = (ns: any) =>
    (ns.path + "/" + ns.name).split("/").slice(1).join("/");

// storagePaths that have a live (re)indexing task for the current service.
//
// Rebuilt on a coalescing timer keyed off the queue LENGTH, rather than as a
// computed over bgTaskQueue: an upload pushes one entry per file, and a computed
// re-runs on every one of those mutations, so rebuilding the set per push was
// O(n²) on the very page doing the uploading. An index badge is not
// latency-critical, so a short coalescing window costs nothing.
const indexingPaths = ref<Set<string>>(new Set<string>());
let indexingPathsTimer: ReturnType<typeof setTimeout> | null = null;
const rebuildIndexingPaths = () => {
    indexingPathsTimer = null;
    const s = new Set<string>();
    for (const e of bgTaskQueue) {
        if (e.projectId === svcId && e.storagePath) s.add(e.storagePath);
    }
    indexingPaths.value = s;
};
watch(
    () => bgTaskQueue.length,
    () => {
        if (indexingPathsTimer !== null) return; // a rebuild is already pending
        indexingPathsTimer = setTimeout(rebuildIndexingPaths, 250);
    },
    { immediate: true }
);

// Server-truth snapshot of the background-indexing queue: storage paths (and
// file names, for older prompts without a path line) that still have a pass
// pending or running. The src:: record a badge lookup finds is written by the
// run's FIRST pass, so its existence never proves the run is over — a
// worker-driven chain keeps going with every tab closed. Only this queue
// probe (the same negative signal the chatbox display relies on) can confirm
// "finished". `checked` is false while unfetched or truncated, in which case
// absence from `keys` proves nothing.
const liveIndexProbe = reactive({
    keys: new Set<string>(),
    checked: false,
    at: 0,
});
let liveProbeInflight: Promise<void> | null = null;
let liveProbeTimer: ReturnType<typeof setTimeout> | null = null;
const LIVE_PROBE_MAX_AGE_MS = 5000;
const LIVE_PROBE_POLL_MS = 8000;

// One queue-idle answer is NOT proof: the worker resolves pass N before it
// enqueues pass N+1 (and the status index is eventually consistent), so every
// pass boundary has a gap where a very-alive chain is invisible to the probe —
// the same race the chat engine re-asks 0/2s/6s for. A file only goes green
// off the queue after TWO confirmed-idle answers from DISTINCT probes at least
// this far apart. Keyed by storagePath; value = the probe timestamp that
// produced the first idle answer.
const pendingGreen = new Map<string, number>();
const GREEN_CONFIRM_GAP_MS = 2000;
// Faster than the 8s live poll: this timer exists only to mint the second
// confirmation look for files already believed done.
const GREEN_CONFIRM_POLL_MS = 2500;
let liveProbeDisposed = false;

const armProbeTimer = (ms: number) => {
    if (liveProbeDisposed) return;
    if (liveProbeTimer !== null) { clearTimeout(liveProbeTimer); }
    const tick = () => {
        liveProbeTimer = null;
        if (liveProbeDisposed) return;
        // A hidden tab re-checks visibility every cycle without asking;
        // progress is server-side either way.
        if (typeof document !== "undefined" && document.hidden) {
            liveProbeTimer = setTimeout(tick, LIVE_PROBE_POLL_MS);
            return;
        }
        void refreshLiveIndexProbe(true);
    };
    liveProbeTimer = setTimeout(tick, ms);
};

const refreshLiveIndexProbe = (force = false): Promise<void> => {
    if (liveProbeDisposed) return Promise.resolve();
    if (!chatReady.value || !selectedAiPlatform.value) return Promise.resolve();
    if (!force && Date.now() - liveIndexProbe.at < LIVE_PROBE_MAX_AGE_MS) {
        return liveProbeInflight || Promise.resolve();
    }
    if (liveProbeInflight) return liveProbeInflight;
    liveProbeInflight = (async () => {
        try {
            const res = await fetchLiveIndexingKeys({
                service: svcId,
                owner: currentService.value?.owner,
                platform: selectedAiPlatform.value as "claude" | "openai",
                userId: user?.user_id,
            });
            if (liveProbeDisposed) return;
            // A file seen LIVE resets its idle confirmation: "two consecutive
            // idle answers" must not be satisfied across a sighting.
            for (const sp of Array.from(pendingGreen.keys())) {
                if (res.keys.has(sp)) pendingGreen.delete(sp);
            }
            liveIndexProbe.keys = res.keys;
            liveIndexProbe.checked = res.checked;
            // Use the answer's own fetch time (engine memo may re-serve a young
            // answer): the pendingGreen ladder compares `at` values to demand
            // two INDEPENDENT looks, and a re-served answer keeps the same
            // stamp so it can never count twice. Fallback for older engine
            // builds that don't return `at` yet.
            liveIndexProbe.at = typeof (res as any).at === "number" ? (res as any).at : Date.now();
            // A trustworthy answer is a resolution event for every row parked
            // in "checking" (by the name-fallback, an unchecked earlier probe,
            // or a pending green confirmation) that is not live now: sweep the
            // transient layer so the re-check below re-decides them.
            let sweep = false;
            if (res.checked) {
                for (const k in indexStatus) {
                    if (indexStatus[k] === "checking" && !res.keys.has(k)) {
                        delete indexStatus[k];
                        sweep = true;
                    }
                }
            }
            if (sweep) {
                checkIndexStatus(
                    (isMobile.value ? mobileAllItems.value : listDisplay.value) as any[]
                );
            }
        } catch (err) {
            // Queue unreachable: keep the previous snapshot; a stale positive
            // is safe (badge stays yellow) and a stale negative is guarded by
            // `checked` only ever being set from a successful answer.
        } finally {
            liveProbeInflight = null;
        }
        if (liveProbeDisposed) return;
        // Keep looking while anything is live, the answer is untrusted, or a
        // green verdict still awaits its second confirmation: worker-driven
        // chains finish with no tab-side event at all.
        if (liveIndexProbe.keys.size > 0 || !liveIndexProbe.checked) {
            armProbeTimer(LIVE_PROBE_POLL_MS);
        } else if (pendingGreen.size > 0) {
            armProbeTimer(GREEN_CONFIRM_POLL_MS);
        }
    })();
    return liveProbeInflight;
};

// A row is "live on the server" when the queue holds a pass for its storage
// path — or its bare name, the only identity very old prompts carried. The
// name fallback can collide across folders, but a false "indexing" merely
// delays the green badge until the queue empties.
const liveOnServer = (sp: string, name: string): boolean =>
    liveIndexProbe.keys.has(sp) || liveIndexProbe.keys.has(name);

// Resolved status for a row, or undefined for folders / not-yet-looked-up files.
// Precedence: live indexing task (client-tracked, then server-tracked) →
// persisted "indexed" → transient lookup state.
const fileIndexState = (ns: any): IndexState | undefined => {
    if (!ns || typeof ns.name !== "string" || ns.name[0] === "#") return undefined;
    const sp = fileStoragePath(ns);
    if (indexingPaths.value.has(sp)) return "indexing";
    if (liveOnServer(sp, ns.name)) return "indexing";
    // run:: record says a run is working — the only live signal for a run
    // another user started. Above the durable green on purpose: a re-index of
    // an already-indexed file must show yellow over the stale green.
    if (runWorking.has(sp)) return "indexing";
    // Stored, but no indexing request was ever accepted for it. Below the live
    // signals (a repair that HAS dispatched should show yellow, not red) and
    // above every "indexed" answer, because all of them are downstream of the
    // `src::` record, which is written BEFORE the dispatch and therefore exists
    // for a file nothing has ever read. Checked here rather than only in the
    // ladder so it can also demote a green that was already cached.
    if (pendingIndexSetupPaths.has(pendingSetupKey(currentService.value?.id, sp))) return "unindexed";
    if (indexedSet.has(sp)) return "indexed";
    // Chat-seeded green: shown while the background pair verifies (a live run
    // above still wins, so a re-index shows yellow over a stale seed).
    if (seededGreen.has(sp)) return "indexed";
    return indexStatus[sp];
};

// Badge icon/title for a row (narrow `state` here so templates never index
// INDEX_BADGE with a possibly-undefined key).
const indexBadgeIcon = (ns: any): string => {
    const s = fileIndexState(ns);
    return s ? INDEX_BADGE[s].icon : "";
};
const indexBadgeTitle = (ns: any): string => {
    const s = fileIndexState(ns);
    return s ? INDEX_BADGE[s].title : "";
};

// Clear only the transient layer (re-verify unindexed files); keeps the
// persisted "indexed" set intact.
const clearIndexStatus = () => {
    for (const k in indexStatus) delete indexStatus[k];
    // Every caller of this wants a genuine re-verify (manual refresh, reindex,
    // a chatbox batch landing) — the negative memo, chat-seeded greens, and
    // the done:: sweep cache must not outlive it (fresh seeds re-derive on the
    // next checkIndexStatus pass).
    unindexedChecked.clear();
    seededGreen.clear();
    runWorking.clear();
    invalidateDoneMarkerSweep(svcId);
};
// Full reset — also drops the persisted "indexed" set so EVERY visible file is
// re-verified. Used by the manual refresh button (deliberate "give me truth").
const resetIndexCache = () => {
    clearIndexStatus();
    indexedSet.clear();
    // A deliberate "give me truth" also restarts the two-look green ladder.
    pendingGreen.clear();
};
// Drop cache entries for deleted files/folders so a later re-upload to the same
// path re-verifies instead of showing a stale "indexed" badge.
const pruneIndexCacheForDeleted = (items: any[]) => {
    for (const v of items) {
        if (!v?.name || typeof v.path !== "string") continue;
        if (v.name[0] === "#") {
            // Folder: prune the folder path itself and everything beneath it.
            const dir = (v.path + "/" + v.name.slice(1)).split("/").slice(1).join("/");
            for (const p of Array.from(indexedSet)) {
                if (p === dir || p.startsWith(dir + "/")) indexedSet.delete(p);
            }
            for (const p of Array.from(unindexedChecked.keys())) {
                if (p === dir || p.startsWith(dir + "/")) unindexedChecked.delete(p);
            }
            for (const p of Array.from(seededGreen)) {
                if (p === dir || p.startsWith(dir + "/")) seededGreen.delete(p);
            }
            for (const p of Array.from(runWorking)) {
                if (p === dir || p.startsWith(dir + "/")) runWorking.delete(p);
            }
            const verdictsDir = chatIndexVerdicts[svcId];
            if (verdictsDir) {
                for (const p of Array.from(verdictsDir.keys())) {
                    if (p === dir || p.startsWith(dir + "/")) verdictsDir.delete(p);
                }
            }
        } else {
            const sp = fileStoragePath(v);
            indexedSet.delete(sp);
            delete indexStatus[sp];
            unindexedChecked.delete(sp);
            seededGreen.delete(sp);
            runWorking.delete(sp);
            // A deleted file's chat verdict must die too, or a re-upload to the
            // same path within the TTL would seed a false green.
            chatIndexVerdicts[svcId]?.delete(sp);
            chatIndexVerdicts[svcId]?.delete(v.name);
        }
    }
};

// Batch-detect indexed status for the given rows. Files only (folders skipped);
// already-indexed (persisted), already-resolved, and in-flight paths are skipped.
//
// "Indexed" (green) requires more than the src:: record existing — that record
// is written by the run's FIRST pass while a worker-driven chain may still be
// reading the file. Green needs one of:
//   • the durable done::<path> marker, written by the backend worker at the end
//     of a chain whose final window reported no more content (one point read); or
//   • the src:: record plus a CONFIRMED-idle indexing queue (liveIndexProbe
//     answered, nothing live for this file) — which also covers files indexed
//     before the marker existed and single-pass runs that never mint one.
// src:: present but the queue still holds a pass -> "indexing" (yellow).
async function checkIndexStatus(items: any[]) {
    if (!chatReady.value || !currentService.value) return;

    const toFetch = (items || []).filter((ns: any) => {
        if (!ns || typeof ns.name !== "string" || ns.name[0] === "#") return false;
        const sp = fileStoragePath(ns);
        // Extracted media (rows under __MEDIA__/) are never indexed themselves
        // and no badge renders for them (template guards on !inMediaDir) — so
        // never spend a getUniqueId pair per image asking.
        if (isMediaDir(sp)) return false;
        // Verdict the CHAT page already established for this file (its rows
        // resolve the same question). The name fallback matters: old prompts
        // carried no storage path, so a chat verdict may be keyed by filename.
        const verdict = (chatIndexVerdicts[svcId]?.get(sp) || chatIndexVerdicts[svcId]?.get(ns.name));
        if (verdict && Date.now() - verdict.at < CHAT_VERDICT_TTL_MS && !indexedSet.has(sp)) {
            // Chat evidence supersedes an older negative memo.
            unindexedChecked.delete(sp);
            if (verdict.state === "confirmed") {
                // Deterministic (single-pass run settled): durable green with
                // no lookup at all. Consume the verdict — from here the
                // durable set carries it.
                indexedSet.add(sp);
                delete indexStatus[sp];
                chatIndexVerdicts[svcId]?.delete(sp);
                chatIndexVerdicts[svcId]?.delete(ns.name);
                return false;
            }
            // 'probable': paint green IMMEDIATELY, but keep this row in the
            // batch — the src::/done:: pair below verifies in the background
            // and promotes or corrects it.
            seededGreen.add(sp);
        }
        // A fresh "unindexed" answer from a recent mount: re-paint the badge
        // from the memo instead of re-firing the lookups (kills the duplicate
        // src:: sweeps when bouncing between the chat and files pages).
        if (indexStatus[sp] === undefined && unindexedFresh(sp) && !indexedSet.has(sp)) {
            indexStatus[sp] = "unindexed";
            return false;
        }
        // Skip: already resolved this mount, or being indexed right now
        // (client- or server-tracked — the finish paths re-check on
        // completion). Durably-GREEN rows deliberately stay in the batch: the
        // sweep consumption below is their only chance to learn about a
        // foreign re-index (yellow) or a demotion (the newest run errored) —
        // they are kept OUT of the legacy per-file ladder further down.
        return (
            indexStatus[sp] === undefined &&
            !indexingPaths.value.has(sp) &&
            !liveOnServer(sp, ns.name)
        );
    });
    if (!toFetch.length) return;

    // ONE records sweep answers done:: AND run:: for every row at once (cached
    // 30s, shared with the chat page). Rows a marker resolves finish here with
    // no per-file request at all; the rest fall through to the LEGACY path — a
    // single src:: lookup + the queue-idle ladder — which now serves only
    // marker-less files (pre-marker history, dead chains).
    const sweep = await sweepIndexMarkers(svcId).catch(() => null);
    const doneSet = sweep ? sweep.done : null;
    const remaining: any[] = [];
    let sawWorking = false;
    if (sweep && doneSet) {
        for (const ns of toFetch) {
            const sp = fileStoragePath(ns);
            const run = sweep.runs.get(sp);
            if (doneSet.has(sp) || run?.status === "done") {
                // Confirmed fully indexed (done:: marker, or the run record's
                // own terminal 'done').
                pendingGreen.delete(sp);
                runWorking.delete(sp);
                indexedSet.add(sp);
                delete indexStatus[sp];
                unindexedChecked.delete(sp);
                seededGreen.delete(sp);
            } else if (run?.status === "error" || run?.status === "cancelled") {
                // The newest run ended without finishing: not indexed — and
                // that DEMOTES a durable green (a re-index that failed leaves
                // the file's old verdict wrong; done:: was checked first, so a
                // legitimately completed file never reaches this branch). The
                // negative memo keeps an imminent remount from re-asking.
                pendingGreen.delete(sp);
                runWorking.delete(sp);
                indexedSet.delete(sp);
                indexStatus[sp] = "unindexed";
                seededGreen.delete(sp);
                unindexedChecked.set(sp, Date.now());
            } else if (
                run?.status === "working" &&
                typeof run.started === "number" &&
                Date.now() - run.started < RUN_RECORD_WORKING_STALE_MS
            ) {
                // A recent run is working — possibly another user's, which the
                // own-queue probe below could never see. Yellow via runWorking;
                // re-verified on a short timer since no finish watcher covers a
                // foreign run. A STALE 'working' (dead chain) falls through to
                // the legacy ladder instead, which reads the actual queue.
                pendingGreen.delete(sp);
                runWorking.add(sp);
                delete indexStatus[sp];
                unindexedChecked.delete(sp);
                sawWorking = true;
            } else {
                // No marker resolved this row (or only a STALE 'working').
                // Reconcile: whatever runWorking believed is no longer backed
                // by a record, so the yellow drops here rather than lingering.
                runWorking.delete(sp);
                // Durably-green rows stop here: the sweep had nothing to say,
                // and green needs no re-proving by the per-file ladder.
                if (!indexedSet.has(sp)) remaining.push(ns);
            }
        }
    } else {
        // Sweep unreachable: keep the old per-file behavior (pair lookups) —
        // for the non-green rows only, exactly as before this consumption
        // block let green rows into the batch.
        remaining.push(...toFetch.filter((ns: any) => !indexedSet.has(fileStoragePath(ns))));
    }
    if (sawWorking) armRunWorkingRecheck();
    if (!remaining.length) return;

    for (const ns of remaining) indexStatus[fileStoragePath(ns)] = "checking";

    // One bounded queue look per batch (cached briefly); the per-file
    // decisions below read the snapshot it refreshes.
    await refreshLiveIndexProbe();

    // A sweep that hit its page cap has an INCOMPLETE done-set: absence proves
    // nothing, so the per-file done:: lookup stays on for the fallthrough rows.
    const doneSetComplete = !!(sweep && doneSet && !sweep.partial);
    await Promise.all(
        remaining.map(async (ns: any) => {
            const sp = fileStoragePath(ns);
            const srcId = "src::" + sp;
            const doneId = indexDoneUniqueId(sp);
            try {
                // The sweep already answered done:: for this row (negative);
                // only when the sweep FAILED (or was truncated) does the
                // per-file done:: lookup still run alongside src::.
                const [srcRes, doneRes]: any[] = await Promise.all([
                    skapi.getUniqueId({ service: svcId, unique_id: srcId }),
                    doneSetComplete ? Promise.resolve(null) : skapi.getUniqueId({ service: svcId, unique_id: doneId }),
                ]);
                const hasSrc = !!srcRes?.list?.some((it: any) => it.unique_id === srcId);
                const hasDone = doneSetComplete ? false : !!doneRes?.list?.some((it: any) => it.unique_id === doneId);
                if (hasDone) {
                    // The backend confirmed the whole file was read to the end.
                    pendingGreen.delete(sp);
                    indexedSet.add(sp);
                    delete indexStatus[sp];
                    unindexedChecked.delete(sp);
                    seededGreen.delete(sp); // promoted to durable
                } else if (pendingIndexSetupPaths.has(pendingSetupKey(svcId, sp))) {
                    // Stored, but its indexing request was never accepted (this
                    // page still holds the durable row saying so). `src::` exists
                    // regardless, because it is written BEFORE the dispatch and
                    // has to be: every pass references it. So every other signal
                    // here reads "indexed" for a file nothing has ever read, and
                    // an idle queue would ripen it into a durable green. This is
                    // the one branch that knows better.
                    pendingGreen.delete(sp);
                    indexedSet.delete(sp);
                    seededGreen.delete(sp);
                    indexStatus[sp] = "unindexed";
                } else if (!hasSrc) {
                    pendingGreen.delete(sp);
                    indexStatus[sp] = "unindexed";
                    // A chat-seeded green was wrong (record deleted since, or a
                    // stale verdict) — the verified answer corrects the badge.
                    seededGreen.delete(sp);
                    // Remember the authoritative negative so an imminent
                    // remount repaints without re-firing the lookups.
                    unindexedChecked.set(sp, Date.now());
                } else if (liveOnServer(sp, ns.name)) {
                    // First pass saved, chain still running: fileIndexState
                    // shows "indexing" from the probe; keep the transient so a
                    // later probe-finish re-resolves this row. A sighting also
                    // voids any idle confirmation collected so far.
                    pendingGreen.delete(sp);
                    indexStatus[sp] = "checking";
                } else if (liveIndexProbe.checked) {
                    // src:: exists and the queue holds nothing live for this
                    // file. One such answer can be a pass-boundary artifact
                    // (see pendingGreen), so green needs a SECOND idle answer
                    // from a fresh probe. Note the queue probed here is this
                    // user's own ("<userId>-bg"): a chain another user or a
                    // widget end-user launched is invisible to it, and those
                    // files stay conservative until their done:: marker lands.
                    const firstIdleAt = pendingGreen.get(sp);
                    if (
                        firstIdleAt !== undefined &&
                        liveIndexProbe.at !== firstIdleAt &&
                        liveIndexProbe.at - firstIdleAt >= GREEN_CONFIRM_GAP_MS
                    ) {
                        pendingGreen.delete(sp);
                        indexedSet.add(sp);
                        delete indexStatus[sp];
                        unindexedChecked.delete(sp);
                        seededGreen.delete(sp); // promoted to durable
                    } else {
                        if (firstIdleAt === undefined) pendingGreen.set(sp, liveIndexProbe.at);
                        // While the ladder walks, a chat-seeded row keeps its
                        // green (fileIndexState puts the seed above the
                        // transient "checking").
                        indexStatus[sp] = "checking";
                    }
                } else {
                    // Queue answer not trustworthy yet; stay "checking" — the
                    // probe's own poll loop re-resolves once it is.
                    indexStatus[sp] = "checking";
                }
            } catch (err) {
                // Leave it unresolved so a later render / refresh retries.
                delete indexStatus[sp];
            }
        })
    );

    // Entries above may have queued a first idle confirmation AFTER the probe's
    // own scheduling tail ran; make sure the second look actually comes.
    if (pendingGreen.size > 0 && liveProbeTimer === null && !liveProbeInflight) {
        armProbeTimer(GREEN_CONFIRM_POLL_MS);
    }
}

// Drop the transient layer and immediately re-check what's on screen — used
// after actions that don't necessarily reassign listDisplay (e.g. reindex).
const refreshIndexStatus = () => {
    clearIndexStatus();
    checkIndexStatus((isMobile.value ? mobileAllItems.value : listDisplay.value) as any[]);
};

// Re-run the batch check whenever the displayed rows change (page, sort, dir,
// refresh). Cached paths are skipped, so repeat renders are cheap.
// `immediate` matters on remount: when returning to this page the pager cache
// is warm, so getFileList populates listDisplay SYNCHRONOUSLY (via the immediate
// dbDirInfo watcher) before this watcher is registered — without immediate that
// initial fill is missed and the badges never resolve. (Fresh mounts fill it
// async, after setup, so the change is caught either way.)
watch(listDisplay, (nv) => checkIndexStatus(nv as any[]), { immediate: true });
watch(mobileAllItems, (nv) => checkIndexStatus(nv as any[]), { immediate: true });

// When a file finishes (re)indexing its bgTaskQueue entry is removed. Its src::
// record now exists, so drop any stale transient entry (a check during indexing
// would have said "unindexed") and re-resolve the on-screen rows so the badge
// flips indexing → indexed.
watch(indexingPaths, (nv, ov) => {
    if (!ov) return;
    let finished = false;
    const finishedDirs = new Set<string>();
    for (const p of ov) {
        if (!nv.has(p)) {
            delete indexStatus[p];
            // The run may have flipped the answer — a stale negative memo
            // would re-seed "unindexed" without asking.
            unindexedChecked.delete(p);
            finished = true;
            finishedDirs.add(p.split("/").slice(0, -1).join("/"));
        }
    }
    // A completed run may have just minted its done:: marker — the cached
    // sweep predates it, so the re-check below must fetch a fresh one.
    if (finished) invalidateDoneMarkerSweep(svcId);
    if (finished) {
        checkIndexStatus(
            (isMobile.value ? mobileAllItems.value : listDisplay.value) as any[]
        );
        // Indexing is what creates extracted media, so a finished run may have
        // minted new __MEDIA__ entries. Re-ask for the directory on screen;
        // for other affected directories just drop the cached listing so the
        // next visit re-asks instead of trusting a stale "no media".
        const cur = dbCurrentDirectory.value || "";
        for (const d of finishedDirs) {
            if (d === cur) loadMediaIndex(cur, true);
            else delete mediaIndex[d];
        }
    }
});

// ─── Collaborator folder labels ───────────────────────────────────────────
// A collaborator's uploads land in a ROOT-LEVEL db folder named by their
// user_id (a uuid). Where we know the collaborator's email we show it instead
// of the raw uuid (resolved lazily via getUsers + cached in
// collaboratorEmailCache), falling back to the raw name until an email is
// available. Only root-level uuid folders are collaborator folders — a
// uuid-named folder nested inside another folder (e.g. /mcp-exports/<uuid>) is
// just an ordinary folder and keeps its raw name + generic folder glyph. A
// listed folder row is at root only when dbCurrentDirectory is empty.
const folderLabel = (name: string): string => {
    const raw = typeof name === "string" && name[0] === "#" ? name.slice(1) : name;
    const sid = currentService.value?.id;
    if (sid && !dbCurrentDirectory.value && isCollaboratorFolderId(raw)) {
        const email = collaboratorEmailCache[sid]?.[raw];
        if (email) return email;
    }
    return raw;
};
// A root-level uuid-named folder is a collaborator's own folder → show a person
// icon instead of the generic folder glyph. Nested uuid folders stay generic.
const folderIcon = (name: string): string => {
    const raw = typeof name === "string" && name[0] === "#" ? name.slice(1) : name;
    return !dbCurrentDirectory.value && isCollaboratorFolderId(raw) ? "person" : "folder";
};
// uuid folders whose email lookup is currently in flight, keyed by raw uuid.
// Reactive so the folder name shows an animated ellipsis until the email (or
// the empty/uuid fallback) arrives. Never resolving below root — nested uuid
// folders aren't collaborator folders, so they show their raw name immediately.
const resolvingFolderEmails = reactive<{ [uuid: string]: boolean }>({});
const folderResolving = (name: string): boolean => {
    if (dbCurrentDirectory.value) return false;
    const raw = typeof name === "string" && name[0] === "#" ? name.slice(1) : name;
    return !!resolvingFolderEmails[raw];
};
// uuid → email substitution for the breadcrumb / "go up" row. Only the ROOT
// segment (index 0) can be a collaborator folder; a uuid segment deeper in the
// path is an ordinary folder and keeps its raw name.
// ─── extracted media ("a file you can go into") ───────────────────────────────
// Pictures pulled out of a document at index time are saved as REAL files in a
// folder mirroring the document's own path under "__MEDIA__", e.g.
//   invoices/report.xlsx  ->  __MEDIA__/invoices/report.xlsx/기체!A88.jpg
// so listing "__MEDIA__/<currentDir>" ONCE names every file in this directory
// that has any: the child folder names ARE those filenames. One request per
// directory, never one per row.
//
// "__MEDIA__" itself never appears in the browser — isReservedDbEntry (/^__.+__$/)
// already filters it out of every listHostDirectory call — so the only way in is
// through the file it belongs to, and the only way out is goUpDir() below.

// dir (relative, "" = root) -> { fileName: true } for files that have media.
// Backed by the module-level per-service dbMediaIndex so navigating away and
// back reuses the listings already fetched instead of re-asking for every
// directory on each visit. Refetches are explicit (refresh=true): the manual
// refresh button, a finishing indexing run (the only thing that creates new
// media), and the stale-arrival path in the dbDirInfo watcher.
if (!dbMediaIndex[svcId]) dbMediaIndex[svcId] = {};
const mediaIndex = dbMediaIndex[svcId];
if (!dbMediaLoading[svcId]) dbMediaLoading[svcId] = {};
const mediaLoading = dbMediaLoading[svcId];

async function loadMediaIndex(dir: string, refresh = false) {
    const key = dir || "";
    if (isMediaDir(key)) return; // no media-of-media
    if (mediaLoading[key] || (!refresh && mediaIndex[key])) return;
    mediaLoading[key] = true;
    try {
        const found: { [name: string]: true } = {};
        let fetchMore = false;
        for (let guard = 0; guard < 50; guard++) {
            const l: any = await currentService.value.listHostDirectory(
                { dir: key ? MEDIA_ROOT + "/" + key : MEDIA_ROOT, target: "db" },
                fetchMore,
                120,
            );
            for (const it of l?.list || []) {
                // Only folders (#name) matter: each is one source file's media.
                if (typeof it?.name === "string" && it.name[0] === "#") {
                    found[it.name.slice(1)] = true;
                }
            }
            if (l?.endOfList) break;
            fetchMore = true;
        }
        mediaIndex[key] = found;
    } catch (err) {
        // No media folder for this directory yet. Leave the entry unset so a
        // later visit retries rather than caching "nothing has media" forever.
    } finally {
        delete mediaLoading[key];
    }
}

/** True when this row is a FILE that has extracted media to go into. */
const hasMedia = (ns: any): boolean => {
    if (!ns || typeof ns.name !== "string" || ns.name[0] === "#") return false;
    return !!mediaIndex[dbCurrentDirectory.value || ""]?.[ns.name];
};

/** Go "into" a file: list the pictures extracted out of it. */
const enterMedia = (ns: any) => {
    if (!hasMedia(ns)) return;
    checked.value = {};
    dbCurrentDirectory.value = MEDIA_ROOT + "/" + fileStoragePath(ns);
};

/**
 * One level up. Leaving a file's media returns to the FILE'S OWN folder, not to
 * the __MEDIA__ mirror above it: that mirror is hidden from the browser, so
 * stepping into it would strand the user in a directory they cannot see or leave
 * by any other route.
 */
const goUpDir = () => {
    const cur = dbCurrentDirectory.value || "";
    if (isMediaDir(cur)) {
        dbCurrentDirectory.value = mediaParentDir(cur);
        return;
    }
    dbCurrentDirectory.value =
        cur.split("/").length === 1 ? "" : cur.split("/").slice(0, -1).join("/");
};

/** Path shown on the "go up" row. Inside a file's media, show the FILE, not the
 *  internal __MEDIA__ prefix the user never chose to enter. */
const displayDir = (dir: string): string => {
    if (!isMediaDir(dir)) return dirLabel(dir);
    return dirLabel(dir.slice(MEDIA_ROOT.length + 1));
};

const dirLabel = (dir: string): string => {
    const sid = currentService.value?.id;
    if (!dir || !sid) return dir || "";
    return dir
        .split("/")
        .map((seg, i) => (i === 0 && isCollaboratorFolderId(seg) && collaboratorEmailCache[sid]?.[seg]) || seg)
        .join("/");
};

// Kick off lazy email resolution for any uuid-named folder currently on screen
// (and any uuid segment of the current path). resolveCollaboratorEmail caches +
// dedups, so repeat renders are cheap; the reactive cache flips each label from
// uuid → email once the lookup lands.
const resolveVisibleCollaboratorFolders = (items: any[]) => {
    const sid = currentService.value?.id;
    if (!sid) return;
    const kick = (raw: string) => {
        // Already cached (a known email, or "" for a no-email user) → nothing
        // to fetch, so never enter the resolving/ellipsis state.
        if (collaboratorEmailCache[sid]?.[raw] !== undefined) return;
        resolvingFolderEmails[raw] = true;
        void resolveCollaboratorEmail(sid, raw).finally(() => {
            delete resolvingFolderEmails[raw];
        });
    };
    // Only root-level uuid folders are collaborator folders, so only resolve
    // emails when the listing itself is at root (dbCurrentDirectory empty).
    if (!dbCurrentDirectory.value) {
        for (const ns of items || []) {
            if (ns?.name?.[0] === "#") {
                const raw = ns.name.slice(1);
                if (isCollaboratorFolderId(raw)) kick(raw);
            }
        }
    }
    // Likewise only the root segment of the current path can be a collaborator
    // folder; deeper uuid segments are ordinary folders and aren't resolved.
    const rootSeg = (dbCurrentDirectory.value || "").split("/")[0];
    if (rootSeg && isCollaboratorFolderId(rootSeg)) kick(rootSeg);
};
watch(listDisplay, (nv) => resolveVisibleCollaboratorFolders(nv as any[]), { immediate: true });
watch(mobileAllItems, (nv) => resolveVisibleCollaboratorFolders(nv as any[]), { immediate: true });

let mobileScrollTicking = false;
const onMobileScroll = () => {
    if (!isMobile.value || !mobileListRef.value || getFileListFetching.value)
        return;
    if (mobileScrollTicking) return;
    mobileScrollTicking = true;
    requestAnimationFrame(() => {
        mobileScrollTicking = false;
        if (!mobileListRef.value) return;

        let rect = mobileListRef.value.getBoundingClientRect();
        let listBottom = rect.top + mobileListRef.value.offsetHeight;

        if (
            listBottom - window.innerHeight < 300 &&
            !isDirEndOfList(dbCurrentDirectory.value || "!") &&
            !getFileListFetching.value
        ) {
            let fetchPage = maxPage.value + 1;
            if (fetchPage !== currentPage.value) {
                currentPage.value = fetchPage;
            }
        }
    });
};

const onMobileTap = (ns: any) => {
    if (ns.name[0] === "#") {
        setNewDir(ns);
    } else {
        openFile(ns);
    }
};

/** Mobile rows have no room for a separate chevron, so the media affordance is
 *  its own tappable icon in the row (see the template). */
const onMobileEnterMedia = (ns: any) => enterMedia(ns);

const mobileGoUp = () => {
    // Shares goUpDir so mobile leaves a file's media the same way desktop does.
    goUpDir();
};

onMounted(() => {
    // Start the project-settings fetch the moment the page opens, so the upload
    // paths that await it (onBeforeBatch's question, resolveUploadAccessGroup)
    // find it settled instead of waiting on a round trip mid-drop. Fire and
    // forget: nothing on this page paints from it, and it cannot fail.
    // Mount-only is enough here: a project switch unmounts this page (see
    // uploadServiceId), unlike agent.vue which survives one.
    primeProjectSettings(uploadServiceId);
    void checkForResumableUploads();
    loadMediaIndex(dbCurrentDirectory.value || "");
    checkMobileResize();
    window.addEventListener("resize", checkMobileResize);
    window.addEventListener("scroll", onMobileScroll, { passive: true });
});

onUnmounted(() => {
    // SETTLE A QUESTION THIS PAGE LEFT OPEN. The prompt is module-level and keyed by
    // project (it has to be: an upload outlives the page that started it), so a modal
    // still open at unmount leaves its resolver unsettled for ever. That silently
    // discards the drop it was asked about, and worse, leaves the surface's single
    // chain pending, so every later question for this project chains off a dead promise
    // and never opens. One route change while the question was up would disable
    // uploads for this project for the rest of the session.
    releaseAccessGroupPrompt();
    window.removeEventListener("resize", checkMobileResize);
    window.removeEventListener("scroll", onMobileScroll);
    if (indexingPathsTimer !== null) clearTimeout(indexingPathsTimer);
    // The disposed flag matters as much as the clearTimeout: a probe INFLIGHT at
    // unmount would otherwise re-arm the loop from its scheduling tail and poll
    // a dead instance (with a stale service id) forever.
    liveProbeDisposed = true;
    if (liveProbeTimer !== null) { clearTimeout(liveProbeTimer); liveProbeTimer = null; }
    if (runWorkingTimer !== null) { clearTimeout(runWorkingTimer); runWorkingTimer = null; }
});
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

/* ─── API key modal scoped overrides (mirrors agent.vue / service.vue) ─── */
.bq-modal-wrap {
    .bq-modal-textarea {
        width: 100%;
        padding: 0.75rem 1rem;
        border: 1px solid @line;
        background: @paper;
        color: @ink;
        font-family: @mono;
        font-size: 0.9rem;
        outline: none;
        margin-bottom: 0.75rem;
        border-radius: 0;
        transition: border-color 0.15s;
        resize: vertical;
        min-height: 4rem;
        word-wrap: break-word;
        overflow-x: hidden;
        white-space: pre-wrap;

        &::placeholder { color: @placeholder; }
        &:focus { border-color: @ink; }
        &:disabled { opacity: 0.5; cursor: default; }
    }

    .btn {
        width: 100%;
        align-self: stretch;
        min-width: 0;
        height: auto;
    }
}

/* ─── info section ─── */
.bq-info-section {
    display: flex;
    flex-direction: column;
    gap: 0;
    border: 1px solid @line;
    font-family: @mono;

    &.disabled {
        opacity: 0.4;
        pointer-events: none;
    }
}

.bq-info-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid @line;

    &:last-child {
        border-bottom: none;
    }
}

.bq-info-label {
    font-size: 0.78rem;
    color: @muted;
    min-width: 5rem;
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.bq-info-value {
    flex: 1;
    font-size: 0.85rem;
    color: @ink;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ─── icon shared ─── */
.bq-icon {
    font-size: 1.4rem;
    color: @muted;
    transition: color 0.15s;
    user-select: none;
    vertical-align: middle;
    cursor: pointer;

    &:hover,
    &.active {
        color: @pink;
    }

    &.disabled {
        opacity: 0.3;
        pointer-events: none;
        cursor: default;
    }

    &.bq-icon--danger {
        &:hover {
            color: @danger;
        }
    }
}

/* ─── toolbar ─── */
.bq-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin: 0.75rem 0 0;
    padding: 0.5rem 0;

    &.disabled {
        opacity: 0.4;
        pointer-events: none;
    }
}

.bq-toolbar-right {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-left: auto;
    flex-shrink: 0;
}

.bq-record-count {
    font-size: 0.75rem;
    color: @muted;
    letter-spacing: 0.02em;
}

.bq-reindex-wrap {
    display: flex;
    align-items: center;
    gap: 0.25rem;

    .bq-icon:hover {
        color: @muted;
    }
}

.bq-reindex-count {
    font-size: 0.75rem;
    color: @muted;
    letter-spacing: 0.02em;
    white-space: nowrap;
}

/* ─── file table ─── */
.bq-empty-drop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: @muted;
    font-family: @mono;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    user-select: none;
    pointer-events: none;
    z-index: 2;

    p {
        margin: 0;
    }
}

:deep(.tableWrap) {
    border: 1px solid @line;
}

:deep(.tableMsg) {
    color: @muted;
}

:deep(.customTbl) {
    background: @paper;

    thead {
        tr {
            &::before,
            &::after {
                display: none;
            }
        }

        th {
            padding: 0.75rem 1rem;
        }
    }

    tbody {
        tr {
            &::before,
            &::after {
                display: none;
            }

            &:hover td {
                border: none;
            }
        }

        td {
            padding: 0 1rem;
            height: 3rem;
            max-height: 3rem;
            box-sizing: border-box;
            overflow: hidden;
            vertical-align: middle;

            /* A name cell headed by the media chevron surrenders its left padding
               to the chevron's hit area (see .bq-media-enter). Nested HERE, not as
               a standalone :deep rule: this block compiles to .customTbl tbody td,
               and a standalone td.bq-name-with-media loses that specificity fight
               and gets overridden right back to 1rem. */
            &.bq-name-with-media {
                padding-left: 0;
            }
        }
    }

    .nohover:hover {
        &::before,
        &::after {
            display: none;
        }
    }
}

:deep(._checkbox) {
    padding: 0 !important;
    color: @ink;

    svg {
        width: 20px;
        height: 20px;
    }
}

.bq-folder-icon {
    font-size: 1.25rem;
    color: @muted;
    vertical-align: sub;
    font-variation-settings: "FILL" 1;

    &--open {
        font-variation-settings: "FILL" 0;
    }
}

/* animated "..." shown on a collaborator folder name while its email resolves */
.bq-folder-ellipsis {
    display: inline-block;
    min-width: 1.2em;
    color: @muted;

    &::after {
        content: "";
        animation: bq-ellipsis 1.5s linear infinite;
    }
}
@keyframes bq-ellipsis {
    0% { content: ""; }
    25% { content: "·"; }
    50% { content: "··"; }
    75% { content: "···"; }
    100% { content: ""; }
}

/* ─── AI-index status badge ─── */
.bq-index-badge {
    font-size: 1.05rem;
    vertical-align: text-top;
    margin-right: 0.35rem;
    flex-shrink: 0;
    user-select: none;
    font-variation-settings: "FILL" 1;

    /* indexed → lit database-search icon */
    &--indexed {
        color: @pink;
    }

    /* not indexed → dim outline icon */
    &--unindexed {
        color: @muted;
        opacity: 0.3;
        font-variation-settings: "FILL" 0;
    }

    /* actively (re)indexing on the server → pink spinner */
    &--indexing {
        color: @pink;
        animation: bq-spin 1.5s linear infinite;
    }

    /* status lookup in flight → muted spinner */
    &--checking {
        color: @muted;
        opacity: 0.6;
        animation: bq-spin 1.5s linear infinite;
    }
}

/* ─── column dropdown ─── */
.bq-th-col {
    position: relative;

    // Sortable header label. Kept inline-block (table.vue's `th span` rule) so
    // the name still ellipsises when the column is resized narrow; the arrow
    // rides along inline instead of in a flex track.
    .bq-sort {
        cursor: pointer;
        // leave room for the absolutely positioned remove-column button
        max-width: calc(100% - 18px);
        transition: color 0.15s;

        &:hover {
            color: @ink;
        }

        &:focus-visible {
            outline: 1px solid @pink;
            outline-offset: 2px;
        }

        &.bq-sort--disabled {
            cursor: default;
            opacity: 0.55;
        }
    }

    .bq-sort-arrow {
        font-size: 1.15rem;
        margin-left: -2px;
        transition: opacity 0.15s, color 0.15s;
    }

    // Reserved but invisible on the columns that are not the applied ordering,
    // so switching columns never reflows the header row. Hovering hints that
    // the column is clickable without competing with the applied one.
    .bq-sort-arrow--idle {
        opacity: 0;
    }

    .bq-sort:hover .bq-sort-arrow--idle {
        opacity: 0.4;
    }

    .bq-sort--disabled .bq-sort-arrow--idle {
        opacity: 0;
    }

    // The applied ordering: exactly one column at a time carries it.
    &.bq-th-sorted {
        .bq-sort,
        .bq-sort:hover {
            color: @pink;
            font-weight: 700;
        }

        .bq-sort-arrow {
            color: @pink;
            opacity: 1;
        }
    }

    .bq-remove-col {
        position: absolute;
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1.1rem;
        color: @muted;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.15s, color 0.15s;
        user-select: none;
        z-index: 1;

        &:hover {
            color: @danger;
        }

        &.disabled {
            opacity: 0.2;
            pointer-events: none;
        }
    }

    &:hover .bq-remove-col {
        opacity: 1;
    }
}

.bq-col-toggle-th {
    position: relative;
    text-align: center;
    cursor: pointer;
    vertical-align: middle;

    .bq-icon {
        font-size: 1.2rem;
    }

    .bq-col-dropdown {
        position: absolute;
        top: calc(100% - 0.5rem);
        right: 0.5rem;
        background: @paper;
        border: 1px solid @muted;
        z-index: 1000;
        padding: 0.2rem;
        box-shadow: 2px 2px 0 var(--bq-shadow);

        :deep(._checkbox) {
            padding: 0.5rem !important;
            font-size: 0.75rem;
            white-space: nowrap;
            cursor: pointer;
            color: @ink;

            > div {
                font-size: 0.75rem;
            }

            &:hover {
                background: @hover-bg;
            }

            svg {
                width: 16px;
                height: 16px;
                vertical-align: middle;
            }
        }
    }
}

:deep(tr.nohover.hoverRow) {
    &:hover {
        cursor: pointer !important;
        background: @hover-bg !important;
    }
}

:deep(tr.bq-row-loading) {
    opacity: 0.6;
    pointer-events: none;
}

.bq-mobile-file-item.bq-row-loading {
    opacity: 0.6;
    pointer-events: none;
}

.bq-upload-icon {
    font-size: 1.25rem;
    color: @muted;
    margin-right: 0.5rem;
    vertical-align: middle;
}

.bq-spin {
    animation: bq-spin 1.5s linear infinite;
}

@keyframes bq-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* ─── pagination ─── */
.bq-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem 8px;
}

.bq-page-btn {
    display: inline-flex;
    align-items: center;
    padding: 0.45rem 0.8rem;
    border: 1px solid @line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.8rem;
    cursor: pointer;
    transition: border-color 0.15s, transform 0.12s ease, box-shadow 0.12s ease;
    border-radius: 0;

    &:hover:not(:disabled) {
        border-color: @ink;
    }

    &:disabled {
        opacity: 0.3;
        cursor: default;
        pointer-events: none;
    }

    &::after {
        display: none;
    }
}

/* ─── AI platform overlay (mirrors agent.vue) ─── */
.bq-apikey-overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    // Sit below the table's sticky header. Header padding (0.75rem * 2) +
    // content ≈ ~3rem; keep in sync with `:deep(.customTbl) thead th` padding.
    top: 3rem;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: color-mix(in srgb, @paper-lit 85%, transparent);
    padding: 1rem;
}

.bq-apikey-overlay-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.85rem;
    text-align: center;
    max-width: 32rem;

    .btn {
        align-self: center;
        min-width: 11rem;
    }

    // Keep the button in its normal active styling while we're fetching the
    // previous API key — disabled fades it out and on mobile the lingering
    // :hover state flips it to white, which makes the dots animation invisible.
    .btn.is-loading-key,
    .btn.is-loading-key:hover,
    .btn.is-loading-key:disabled,
    .btn.is-loading-key:focus,
    .btn.is-loading-key:active {
        opacity: 1;
        background: @ink;
        color: @paper;
        cursor: progress;
    }
}

.bq-apikey-logo {
    width: 3rem;
    height: 3rem;
    object-fit: contain;
}

.bq-apikey-help {
    margin: 0;
    color: @muted;
    font-size: 0.83rem;
    line-height: 1.4;
}

.bq-platform-overlay-options {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: center;
}

.bq-platform-overlay-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 9rem;

    .bq-apikey-logo {
        width: 1.25rem;
        height: 1.25rem;
    }
}

.bq-link {
    color: @pink;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

/* ─── drag popup ─── */
.bq-drag-popup {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: color-mix(in srgb, @paper-lit 85%, transparent);
    border: 2px dashed @pink;
    color: @pink;
    font-family: @mono;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    user-select: none;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 10;

    &.show {
        opacity: 1;
    }

    p {
        margin: 0;
    }
}

.bq-table-disabled {
    pointer-events: none;

    :deep(thead) {
        opacity: 0.5;
    }
}

.bq-upload-loading-status {
    position: relative;
    z-index: 5;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0.75rem;
    font-size: 0.85rem;
    background: var(--bq-surface, #fff);
    border-bottom: 1px solid @line;
}

.bq-table-wrap {
    position: relative;
    overflow: hidden;
    margin-top: 0.25rem;

    &.bq-uploading::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 3px;
        width: var(--upload-progress, 0%);
        background: @pink;
        z-index: 10;
        pointer-events: none;
        transition: width 0.3s ease;
    }

    // Preparing (no byte progress yet): barber pole across the full width, the
    // same treatment the chat chips use. A 30% block sliding left-to-right was
    // easy to read as real movement through the file; stripes are unambiguously
    // "working, no measurement yet".
    &.bq-uploading--indeterminate::before {
        width: 100%;
        transition: none;
        background: repeating-linear-gradient(
            -45deg,
            @pink 0 8px,
            color-mix(in srgb, @pink 35%, transparent) 8px 16px
        );
        background-size: 22.6px 100%;
        animation: bq-upload-barber 0.8s linear infinite;
    }
}

:deep(.bq-upload-row),
:deep(.bq-status-row),
:deep(tr:has(> td > .bq-sticky-info)) {
    td {
        overflow: visible !important;
        background: transparent;
    }
}

/* ─── upload access-group chooser ─── */
// A radio list rather than a button row: the three answers are not equally
// weighted, and the hint under each is what actually distinguishes them.
.bq-access-options {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    margin: 0.85rem 0 0;
    text-align: left;

    .bq-access-option {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: baseline;
        column-gap: 0.5rem;
        padding: 0.5rem 0.6rem;
        cursor: pointer;
        user-select: none;

        &:hover {
            background: @hover-bg;
        }

        input {
            cursor: pointer;
            margin: 0;
        }
    }

    .bq-access-option-label {
        font-size: 0.9rem;
    }

    .bq-access-option-hint {
        grid-column: 2;
        margin-top: 0.15rem;
        font-size: 0.78rem;
        line-height: 1.35;
        color: @muted;
    }
}

/* ─── upload-failure modal list ─── */
.bq-overwrite-applyall {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin-top: 0.85rem;
    font-size: 0.85rem;
    cursor: pointer;
    user-select: none;

    input {
        cursor: pointer;
        margin: 0;
    }
}

// upload error report dialog (failed files grouped by cause) — mirrors the
// report agent.vue's chatbox shows for failed attachments.
.bq-upload-error-list {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    margin-top: 0.4rem;
    max-height: 50vh;
    overflow-y: auto;
}
.bq-upload-error-group {
    border-left: 3px solid @danger;
    padding-left: 0.7rem;
}
.bq-upload-error-heading {
    margin: 0 0 0.3rem;
    font-size: 0.82rem;
    font-weight: 600;
    color: @danger;
    word-break: break-word;
}
.bq-upload-error-files {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 0.8rem;
    color: @ink;

    li {
        margin: 0.1rem 0;
        line-height: 1.5;
        word-break: break-all;
    }
}

:deep(.bq-sticky-info) {
    position: sticky;
    left: 0;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    padding: 0 1rem;
}

/* "go into this file" chevron, at the head of the name column.

   The glyph alone (~18px) was the whole click target inside a 3rem row. The cell
   surrenders its 1rem left padding on chevron rows (td.bq-name-with-media, nested in the .customTbl block) and
   the chevron absorbs it as padding of its own, plus the full row height and a
   slice of the gap before the filename - so the target grows to the whole head of
   the cell while the glyph and the filename render exactly where they always did
   (padding-left restores the 1rem inset; margin-right cancels the extra
   padding-right down to the original 0.15rem gap). */
:deep(.bq-media-enter) {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    height: 3rem;
    padding: 0 0.5rem 0 1rem;
    margin-right: -0.35rem;
    font-size: 1.15rem;
    cursor: pointer;
    opacity: 0.55;

    &:hover {
        opacity: 1;
    }
}


/* ─── sticky checkbox column ─── */
:deep(.bq-sticky-check) {
    position: sticky;
    left: 0;
    z-index: 2;
    background: @paper;

    &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        background: @line;
    }
}

@keyframes bq-upload-barber {
    to {
        background-position: 22.6px 0;
    }
}

/* ─── mobile ─── */
.bq-mobile-list {
    display: none;
}

.bq-mobile-status {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid @line;
    font-size: 0.85rem;
    color: @muted;
    position: relative;
}

.bq-mobile-status-icon {
    flex-shrink: 0;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.1rem;

    .material-symbols-outlined {
        font-size: 1.25rem;
    }
}

.bq-mobile-status-text {
    flex: 1;
    min-width: 0;
}

.bq-mobile-status-title {
    font-size: 0.85rem;
    color: @ink;
}

.bq-mobile-status-detail {
    font-size: 0.78rem;
    color: @muted;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 0.1rem;
}

.bq-mobile-status-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: @line;
    overflow: hidden;
}

.bq-mobile-status-bar-fill {
    height: 100%;
    background: @pink;
    transition: width 0.3s ease;

    &--indeterminate {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        transition: none;
        background: repeating-linear-gradient(
            -45deg,
            @pink 0 8px,
            color-mix(in srgb, @pink 35%, transparent) 8px 16px
        );
        background-size: 22.6px 100%;
        animation: bq-upload-barber 0.8s linear infinite;
    }
}

.bq-mobile-file-item {
    display: flex;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid @line;
    cursor: pointer;
    min-height: 62px;
    box-sizing: border-box;

    &:active {
        background: @hover-bg;
    }
}

.bq-mobile-file-icon {
    flex-shrink: 0;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.75rem;
}

/* In the mobile icon slot the chevron stands in for the file icon, so it has to
   sit like an icon rather than like the inline glyph it is in the desktop name
   column (where it is baseline-aligned next to text). */
.bq-mobile-file-icon :deep(.bq-media-enter),
.bq-mobile-file-icon .bq-media-enter {
    vertical-align: baseline;
    /* Same hit-area treatment as the desktop chevron: the tap target fills the
       row height and bleeds into the surrounding gaps; the negative margins keep
       the glyph sitting exactly where the file icon it replaces would sit. */
    display: inline-flex;
    align-items: center;
    height: 100%;
    padding: 0.6rem 0.5rem;
    margin: -0.6rem -0.5rem;
    font-size: 1.4rem;
    opacity: 1;
}

.bq-mobile-file-info {
    flex: 1;
    min-width: 0;
}

.bq-mobile-file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.9rem;
}

.bq-mobile-file-size {
    font-size: 0.78rem;
    color: @muted;
    margin-top: 0.15rem;
}

.bq-mobile-file-delete {
    flex-shrink: 0;
    font-size: 1.2rem !important;
    color: @muted;
    margin-left: 0.5rem;
    cursor: pointer;

    &:active {
        color: @danger;
    }
}

.bq-mobile-file-chevron {
    flex-shrink: 0;
    font-size: 1.2rem !important;
    color: @muted;
    margin-left: 0.5rem;
}

.bq-file-icon {
    color: @muted;
}

.bq-mobile-placeholder,
.bq-mobile-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    color: @muted;
}

.bq-mobile-end {
    text-align: center;
    padding: 1.5rem;
    font-size: 0.82rem;
    color: @muted;
}

.bq-mobile-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    text-align: center;
    padding: 3rem 1rem;
    color: @muted;
    font-size: 0.9rem;
    cursor: pointer;
    user-select: none;
    transition: color 0.15s;

    &:hover {
        color: @ink;
    }
}

.bq-mobile-empty-icon {
    font-size: 4rem;
    color: @pink;
}

.bq-mobile-empty-label {
    font-family: @mono;
}

@media (max-width: 768px) {
    :deep(.bq-sticky-check) {
        display: none;
    }

    [data-track="dbfile_delete_selected_icon"],
    [data-track="dbfile_folder_icon"] {
        display: none;
    }

    .bq-desktop-only {
        display: none !important;
    }

    .bq-mobile-list {
        display: block;
        position: relative;
        min-height: 12rem;
    }

    // On mobile the overlay covers the entire mobile list (no sticky header
    // to clear) — match agent.vue's overlay exactly.
    .bq-apikey-overlay {
        top: 0;
        background: color-mix(in srgb, @paper-lit 85%, transparent);
    }

    // Match agent.vue mobile: overlay buttons span full width.
    .bq-apikey-overlay-inner .btn,
    .bq-platform-overlay-btn {
        width: 100%;
    }
}
</style>
